/* ============================================================================
   RENKEISEN · rk-ui.js
   Comportamientos compartidos y minimos del tema. Cargar con defer.
     0. Formateo de cifras (window.rkFormato). Dueño unico para todo el tema.
     1. Revelado al scroll, un unico observador para todo el documento.
     2. Galeria de la ficha de producto.
     3. Formulario de contra entrega bajo demanda.
     4. Decision de pago en el carro.
     5. Corte horario de despacho (PRISMA VIVO).
     6. Cifra de ahorro que cuenta hacia arriba (PRISMA VIVO).
     7. Agregar al carro sin recargar (PRISMA VIVO).
     8. Riel movil que aparece al salir el hero (PRISMA VIVO).
   Respeta prefers-reduced-motion en todo lo que se mueve.
============================================================================ */
(function(){
  "use strict";
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 0. formateo de cifras: el unico sitio donde se decide ----------
     DOS FUNCIONES QUE SE PARECEN Y NO SON LO MISMO. Las dos escupen un numero
     chileno con puntos de millar, y elegir la equivocada no falla: miente.

     monto()  recibe CENTAVOS y divide por cien. Shopify guarda todo importe en
              la unidad menor de la moneda, incluso en pesos chilenos que no
              usan decimales: $78.990 se almacena como 7899000. El filtro money
              de Liquid ya divide, pero un valor crudo que viaja a JavaScript
              por un atributo NO, y sin la division el ahorro de la ficha se
              mostraba cien veces mas grande: $5.600.000 en vez de $56.000.
     conteo() recibe una cantidad de cosas y NO divide nada. Pasar un conteo
              por monto() lo destroza: la portada anunciaba "$1 productos" y
              "$0 categorias", que eran 50/100 y 6/100 formateados como plata.

     POR QUE ESTOS NOMBRES. Los anteriores —pesos() y enteroCL()— describian la
     salida, y como las dos salidas se ven igual el nombre no ayudaba a elegir.
     Estos nombran el DATO DE ENTRADA, que es lo unico que distingue un caso del
     otro cuando uno esta frente a la variable. Y van dentro de un mismo objeto,
     no sueltos en window, para que sea imposible encontrar uno sin ver al lado
     al otro: la confusion entre ambos es el fallo que esto previene, asi que se
     tocan de a dos o no se tocan.
     El prefijo rk lo comparten window.rkModo, rkOnCategoria y rkPdpVivo; nada
     mas en el tema se llama Formato.

     Vive en window porque rk-global.js tambien necesita formatear montos.
     Habia una copia identica alla, y mientras existieron las dos el arreglo de
     cada aparicion del bug se hizo en una sola de ellas. */
  var monto = function(centavos){
    var n = Math.round(centavos / 100);
    try { return '$' + new Intl.NumberFormat('es-CL').format(n); }
    catch(e){ return '$' + n; }
  };

  var conteo = function(cantidad){
    var v = Math.round(cantidad);
    try { return new Intl.NumberFormat('es-CL').format(v); }
    catch(e){ return String(v); }
  };

  window.rkFormato = { monto: monto, conteo: conteo };

  /* ---------- 3. formulario de contra entrega: revelado bajo demanda ----------
     UN SOLO PATRON PARA TODO EL SITIO. Antes esto era un modal que se
     apoyaba en la estructura interna de Releasit: usaba su contenedor
     ._rsi-buy-now-button-app-block-hook como capa oscurecida y su
     #rsi_form_wrapper como panel. Eso funcionaba mientras Releasit inyectara
     el formulario DENTRO del hook.

     El 20-08-2026, al agregar el boton "Agregar al carro" a la ficha, dejo de
     hacerlo: Releasit detecta el formulario de producto de la pagina y se
     inyecta al lado, o sea dentro de la columna de decision y FUERA del hook.
     El resultado era un formulario de direccion completo incrustado entre el
     precio y los botones, apareciendo de forma asincrona y empujando el
     layout (CLS de 0.097 medido en escritorio, con el empujon justo sobre el
     argumento de venta).

     La solucion no es perseguir donde inyecta Releasit, porque eso vuelve a
     cambiar con cada version de la app. Es no depender de su estructura:
     el formulario se oculta este donde este, y se revela en su sitio cuando
     el cliente pide contra entrega, con un desplazamiento suave hasta el.
     Es el mismo patron que ya usa el carro, asi que hay un solo
     comportamiento que entender en todo el sitio.

     A PRUEBA DE FALLOS: la clase rk-cod-oculto la agrega ESTE script. Si el
     JavaScript no corre, la clase no existe, el CSS no aplica y el
     formulario queda visible en el flujo como siempre. Nunca se deja al
     cliente sin forma de pedir contra entrega. */
  var raizCod = document.documentElement;
  raizCod.classList.add('rk-cod-js');

  /* MODAL, 26-08-2026. Antes esto revelaba el formulario donde Releasit lo
     hubiera inyectado. Releasit lo inyecta como PRIMER HIJO DE <body>, o sea
     por encima de la cabecera: al revelarlo aparecia arriba del todo, suelto y
     lejos del producto. Ahora se revela como modal centrado.
     No se mueve ni un nodo de su DOM, solo cambia la presentacion por CSS,
     porque su propio script depende de su estructura interna. */
  var cerrarCod = function(){
    quitarCerrar();
    raizCod.classList.remove('rk-cod-abierto');
    raizCod.classList.add('rk-cod-oculto');
    document.documentElement.style.overflow = '';
  };
  window.rkCerrarCod = cerrarCod;

  /* Boton de cerrar propio. Releasit no siempre pinta el suyo, y sin el el
     cliente entra al modal y no tiene como salir: en el telefono no hay tecla
     Escape y, con el panel a pantalla completa, tampoco queda velo que pulsar.
     Se cuelga de <body>, NUNCA dentro del contenedor de Releasit, y se coloca
     por encima con CSS. Asi no se toca ni un nodo suyo. */
  var botonCerrar = null;
  var ponerCerrar = function(){
    if(botonCerrar){ return; }
    botonCerrar = document.createElement('button');
    botonCerrar.type = 'button';
    botonCerrar.className = 'rk-cod-x';
    botonCerrar.setAttribute('data-rk-cod-cerrar', '');
    botonCerrar.setAttribute('aria-label', 'Cerrar');
    botonCerrar.textContent = '\u00D7';
    document.body.appendChild(botonCerrar);
  };
  var quitarCerrar = function(){
    if(botonCerrar && botonCerrar.parentNode){ botonCerrar.parentNode.removeChild(botonCerrar); }
    botonCerrar = null;
  };
  window.rkQuitarCerrarCod = quitarCerrar;

  /* ==========================================================================
     RESCATES DEL FORMULARIO DE CONTRA ENTREGA            02-09-2026

     Tres fallos que impedian o envenenaban la compra en telefono. Los tres
     estan DENTRO del formulario de Releasit, asi que no se toca su codigo:
     se corrigen desde fuera, sobre el DOM que ya pinto, y de la forma menos
     invasiva que funciona. Si algun dia la app los arregla, esto deja de
     hacer efecto solo y no estorba.
     ========================================================================== */

  /* ---- 1. LA VENTANA VISIBLE ----
     El modal es fixed y se medira con --rk-vv. Solo visualViewport sabe
     cuanto queda visible con el teclado arriba: innerHeight no se entera. */
  var medirVentana = function(){
    var vv = window.visualViewport;
    var alto = vv ? vv.height : window.innerHeight;
    if (alto > 0) {
      document.documentElement.style.setProperty('--rk-vv', Math.round(alto) + 'px');
    }
  };
  medirVentana();
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', medirVentana);
    window.visualViewport.addEventListener('scroll', medirVentana);
  }
  window.addEventListener('orientationchange', function(){ setTimeout(medirVentana, 260); });

  /* ---- 2. EL ENLACE DE TERMINOS DEJA DE BORRAR EL FORMULARIO ----
     Su <a> no llevaba target, asi que navegaba en la misma pestana. Al volver
     con el boton atras el formulario aparecia cerrado y los NUEVE campos en
     blanco: el cliente hacia lo unico que el formulario le pide, leer lo que
     va a aceptar, y perdia todo lo escrito. Y ese enlace ocupa 182 de los 261
     px de la etiqueta que hay que tocar para marcar la casilla obligatoria,
     asi que mucha gente lo pulsaba sin querer.
     Cerrar con la equis SI conservaba los datos, o sea que el formulario sabe
     guardar estado: el unico que lo destruia era la navegacion. */
  var arreglarEnlaces = function(raiz){
    if (!raiz) { return; }
    var enlaces = raiz.querySelectorAll('a[href*="/policies/"], a[href*="/pages/"]');
    for (var i = 0; i < enlaces.length; i++) {
      if (enlaces[i].getAttribute('target') === '_blank') { continue; }
      enlaces[i].setAttribute('target', '_blank');
      enlaces[i].setAttribute('rel', 'noopener');
    }
  };

  /* ---- 3. EL TELEFONO ----
     La app corta el campo en 9 caracteres y descarta en silencio cualquier
     cambio que lo pase. Medido: "+56912345678" quedaba "+56912345", y pegado
     desde el portapapeles quedaba VACIO. La validacion solo mide el largo, no
     el contenido, asi que cualquier cosa de 9 caracteres pasa por buena. En
     contra entrega el courier llama para coordinar: el pedido se crea, el
     numero no existe, y nadie se entera hasta que falla la entrega.

     Aca se limpia ANTES de que la app lo vea: se dejan solo digitos, se quita
     el 56 de pais si sobra, y se conservan los ultimos nueve, que es un movil
     chileno (9XXXXXXXX) o un fijo (2XXXXXXXX). Se escribe con el setter
     nativo y se emite un evento input porque el campo es de React: asignar
     .value a secas no le llega y el valor se pierde al siguiente repintado. */
  var limpiarFono = function(txt){
    var d = String(txt || '').replace(/\D/g, '');
    if (d.length > 9 && d.indexOf('56') === 0) { d = d.slice(2); }
    if (d.length > 9) { d = d.slice(-9); }
    return d;
  };
  var escribirNativo = function(el, valor){
    try {
      var desc = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(el), 'value');
      if (desc && desc.set) { desc.set.call(el, valor); } else { el.value = valor; }
      el.dispatchEvent(new Event('input', { bubbles: true }));
    } catch(e) { el.value = valor; }
  };

  /* EL DANO OCURRE AL TECLEAR, NO AL SALIR DEL CAMPO.
     El primer intento limpiaba en blur y no servia de nada: la app corta a 9
     caracteres MIENTRAS se escribe, asi que al salir del campo la informacion
     ya estaba perdida. "+56912345678" llegaba a blur como "+56912345" y de
     ahi no se puede recuperar el numero.
     Hay que impedir que los caracteres que no son digitos consuman el cupo de
     nueve, y deshacer el prefijo de pais en cuanto aparece. Con estas dos
     reglas, tecleando "+56 9 1234 5678" queda 912345678:
       el "+" y los espacios no entran nunca
       cuando el campo vale exactamente "56" se vacia, porque en Chile ningun
       numero empieza asi: es el prefijo que el campo ya muestra a la
       izquierda, escrito otra vez. */
  document.addEventListener('beforeinput', function(ev){
    var el = ev.target;
    if (!el || el.name !== 'phone') { return; }
    if (typeof ev.data !== 'string' || ev.data === '') { return; }
    var soloDig = ev.data.replace(/\D/g, '');
    if (soloDig === ev.data) { return; }
    ev.preventDefault();
    if (soloDig) {
      var el2 = el;
      escribirNativo(el2, (el2.value || '') + soloDig);
    }
  }, true);

  document.addEventListener('input', function(ev){
    var el = ev.target;
    if (!el || el.name !== 'phone') { return; }
    if (el.value === '56' || el.value === '+56') { escribirNativo(el, ''); }
  }, true);

  document.addEventListener('paste', function(ev){
    var el = ev.target;
    if (!el || el.name !== 'phone') { return; }
    var t = (ev.clipboardData || window.clipboardData);
    if (!t) { return; }
    var limpio = limpiarFono(t.getData('text'));
    if (!limpio) { return; }
    ev.preventDefault();
    escribirNativo(el, limpio);
  }, true);

  document.addEventListener('blur', function(ev){
    var el = ev.target;
    if (!el || el.name !== 'phone') { return; }
    var limpio = limpiarFono(el.value);
    if (limpio && limpio !== el.value) { escribirNativo(el, limpio); }
  }, true);

  /* Los tres se aplican cada vez que la app repinta: es React y puede
     reemplazar sus nodos, y entonces el enlace volveria a nacer sin target. */
  if (typeof MutationObserver === 'function') {
    var obsCod = new MutationObserver(function(){
      arreglarEnlaces(document.querySelector('#rsi_form_wrapper'));
    });
    obsCod.observe(document.documentElement, { childList: true, subtree: true });
  }

  var revelarCod = function(ev){
    if(ev){ ev.preventDefault(); }
    ponerCerrar();
    raizCod.classList.add('rk-cod-abierto');
    document.documentElement.style.overflow = 'hidden';
    medirVentana();
    arreglarEnlaces(document.querySelector('#rsi_form_wrapper'));
    raizCod.classList.remove('rk-cod-oculto');
    var destino = document.querySelector('#rsi-form-top-anchor, #rsi_form_wrapper, ._rsi_main_form_element');
    if(destino){
      setTimeout(function(){
        destino.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        var primero = destino.querySelector('input, select, textarea');
        if(primero){ setTimeout(function(){ primero.focus({ preventScroll: true }); }, reduce ? 0 : 420); }
      }, 40);
    }
  };

  /* En la ficha nace oculto. En el carro lo maneja el bloque 4, que decide
     segun la opcion de pago elegida. */
  if(!document.body.classList.contains('rk-tpl-carro')){
    raizCod.classList.add('rk-cod-oculto');
  }

  document.addEventListener('click', function(ev){
    var t = ev.target;
    if(!t || !t.closest) return;
    if(t.closest('[data-rk-cta="cod"], [data-rk-cod-abrir]')){
      /* Releasit NO monta su formulario cuando la variante pedida no tiene
         stock. Sin esta comprobacion el velo se abria igual y quedaba negro
         y vacio, con solo la equis. En el carro el montaje es otro
         (#cart-wrapper), por eso la guarda se limita a la ficha. */
      var hayForm = document.querySelector('#rsi-form-top-anchor, #rsi_form_wrapper, ._rsi_main_form_element');
      if(!hayForm && document.body.classList.contains('rk-tpl-producto')){ ev.preventDefault(); return; }
      revelarCod(ev); return;
    }
    if(!raizCod.classList.contains('rk-cod-abierto')) return;
    if(t.closest('.rsi-form-close-button, [data-rk-cod-cerrar]')){ cerrarCod(); return; }
    /* clic en el velo: dentro del hook pero fuera del panel */
    if(t.closest('._rsi-buy-now-button-app-block-hook') && !t.closest('#rsi_form_wrapper')){ cerrarCod(); }
  });

  document.addEventListener('keydown', function(ev){
    if(ev.key === 'Escape' && raizCod.classList.contains('rk-cod-abierto')){ cerrarCod(); }
  });

  /* si alguien llega con el ancla en la URL, se revela solo */
  if(location.hash === '#rsi-form-top-anchor'){ revelarCod(null); }

  /* ---------- 4. decision de pago en el carro ----------
     El cliente elige entre pagar ahora (con el descuento ya aplicado) o
     pagar al recibir, y un unico boton primario cambia de destino segun lo
     elegido. Ver el comentario largo de sections/rk-carro-decision.liquid
     para el porque; lo esencial es que el boton nativo de Dawn iba a
     /checkout sin el cupon y le costaba al cliente el 10% prometido.

     El formulario de contra entrega de Releasit ya vive en esta pagina,
     pero enterrado al final y sin que nada anuncie que existe. Aca se
     oculta hasta que el cliente elige esa ruta, y ahi se revela y se baja
     hasta el.

     A PRUEBA DE FALLOS: la clase rk-cod-oculto la pone ESTE script. Si el
     JS no corre, la clase no existe, el CSS no aplica, el formulario queda
     visible en el flujo como siempre estuvo y el boton conserva el enlace
     de prepago que ya trae puesto desde Liquid. Nunca se deja al cliente
     sin forma de comprar.

     UN SOLO SENTIDO DE ESCRITURA. Antes esta pantalla llevaba su propio
     estado y ademas se forzaba a prepago al cargar, sin mirar el modo del
     sitio que rk-global.js guarda en localStorage. Con el modo global en
     prepago y el cliente pulsando "Pagar al recibir", el destino del boton
     se iba al formulario de contra entrega pero el subtotal grande —que lo
     reescribe rk-global.js— seguia mostrando el neto: la cifra mas grande de
     la pantalla contradecia lo que se iba a cobrar.
     Ahora el clic escribe en el modo global (window.rkModo) y es el modo
     global el que manda a repintar esta pantalla, por el evento rk:modo.
     pintarPago solo pinta y nunca escribe hacia arriba, que es lo que
     impide que los dos se llamen en circulo. */
  var carro = document.querySelector('[data-rk-carro]');
  if(carro && document.body.classList.contains('rk-tpl-carro')){
    var raizC = document.documentElement,
        boton = carro.querySelector('[data-rk-ir]'),
        texto = carro.querySelector('[data-rk-ir-texto]'),
        subtx = carro.querySelector('[data-rk-ir-sub]'),
        opts  = Array.prototype.slice.call(carro.querySelectorAll('[data-rk-opt]'));

    if(boton && texto && subtx && opts.length){
      raizC.classList.add('rk-cod-oculto');

      /* El formulario de Releasit vive mas abajo en la pagina, asi que
         revelarlo sin bajar hasta el deja al cliente mirando el mismo
         encuadre y creyendo que no paso nada. */
      var bajarAlFormulario = function(){
        var destino = document.querySelector('#rsi-form-top-anchor, #rsi_form_wrapper');
        if(!destino){ return; }
        setTimeout(function(){
          destino.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        }, 60);
      };

      /* Que modo esta elegido ahora mismo. Antes no hacia falta guardarlo,
         porque la visibilidad del formulario se deducia del modo. Ahora que
         las dos cosas se separan, el boton necesita consultarlo. */
      var modoActual = null;

      var pintarPago = function(cual, porClic){
        opts.forEach(function(o){
          var esta = o.getAttribute('data-rk-opt') === cual;
          o.classList.toggle('is-elegida', esta);
          var r = o.querySelector('input[type="radio"]');
          if(r){ r.checked = esta; }
        });

        var esCod = cual === 'cod';
        modoActual = cual;
        /* AQUI ESTABA EL BUG. Habia una linea que ataba la clase que
           esconde el formulario al valor de esCod, encendiendola y
           apagandola con el modo.
           Mientras el modo por defecto fue prepago nadie lo noto, pero al
           pasar el defecto a contra entrega el formulario de Releasit
           quedaba desplegado entero nada mas abrir /cart: resumen, metodo
           de envio, los 11 campos de direccion y su propio boton de pagar,
           sin que el cliente hubiera pedido nada.
           Elegir COMO se paga no es lo mismo que pedir el formulario. La
           unica pieza que lo revela es el boton de continuar, mas abajo.
           Si el cliente se pasa a prepago, se vuelve a esconder. */
        if(!esCod){ raizC.classList.add('rk-cod-oculto'); }
        /* Las dos rutas se leen del contrato data-url-cod / data-url-pre, el
           mismo que usa rk-global.js, para que las dos piezas no puedan
           discrepar sobre el destino. data-rk-url-prepago queda de respaldo
           por si algun dia el marcado llega sin el par. */
        boton.setAttribute('href', esCod
          ? (boton.getAttribute('data-url-cod') || '#rsi-form-top-anchor')
          : (boton.getAttribute('data-url-pre') || boton.getAttribute('data-rk-url-prepago')));
        texto.textContent = boton.getAttribute(esCod ? 'data-rk-texto-cod' : 'data-rk-texto-prepago');
        subtx.textContent = boton.getAttribute(esCod ? 'data-rk-sub-cod' : 'data-rk-sub-prepago');

        /* Elegir la opcion ya no baja al formulario: a estas alturas sigue
           escondido. Quien lo revela y baja hasta el es el boton. */
      };

      var elegirPago = function(cual, porClic){
        pintarPago(cual, porClic);
        /* Si rk-global.js no llego a cargar, la pantalla igual queda
           coherente consigo misma; lo que se pierde es la sincronia con el
           resto del sitio, no la posibilidad de comprar. */
        if(typeof window.rkModo === 'function'){
          window.rkModo(cual === 'prepago' ? 'pre' : 'cod');
        }
      };

      /* UNA SOLA SEÑAL DE ELECCION: el change del radio.
         Cada opcion es un <label> con su radio adentro, y eso hace que un
         clic sobre la etiqueta produzca tres eventos, no uno: el clic sobre
         el <label>, el clic sintetico que el navegador reenvia al input y que
         burbujea de vuelta hasta el mismo <label>, y el change. Antes habia
         un manejador en el <label> ademas del change, asi que elegir contra
         entrega ejecutaba esto tres veces. El estado convergia, pero se
         encolaban tres scrollIntoView y el descenso hasta el formulario se
         sentia pegajoso.
         El change basta y no deja fuera al teclado: la barra espaciadora y
         las flechas marcan el radio igual que el puntero. */
      opts.forEach(function(o){
        var cual = o.getAttribute('data-rk-opt');
        var r = o.querySelector('input[type="radio"]');

        if(!r){
          /* respaldo para un marcado sin radio anidado: ahi el clic es la
             unica señal que hay, y no puede duplicarse con nada */
          o.addEventListener('click', function(){ elegirPago(cual, true); });
          return;
        }

        r.addEventListener('change', function(){ if(r.checked){ elegirPago(cual, true); } });

        /* Volver a pulsar la opcion YA elegida no dispara change, y es como
           el cliente pide "llevame al formulario" cuando ya lo tiene
           revelado mas abajo. Se atiende solo ese caso y solo el
           desplazamiento; el estado no se toca porque no cambio.
           Cuando el label todavia no esta elegido, r.checked es false
           mientras corre este manejador —el navegador marca el radio despues
           de despachar el clic del label— y el clic sintetico posterior llega
           con el input como target: los dos casos se descartan aca y la
           eleccion queda entera en manos del change. */
        o.addEventListener('click', function(ev){
          if(!r.checked || ev.target === r){ return; }
          /* Este caso es el cliente pidiendo "llevame al formulario que ya
             tengo revelado abajo", tal como decia el comentario de arriba.
             Si todavia no lo revelo, no hay a donde bajar. */
          if(cual === 'cod' && !raizC.classList.contains('rk-cod-oculto')){ bajarAlFormulario(); }
        });
      });

      /* EL BOTON ES QUIEN PIDE EL FORMULARIO.
         En prepago es un enlace normal hacia el checkout y se deja pasar sin
         tocarlo. En contra entrega revela el formulario y baja hasta el.
         De Releasit no se toca nada: solo se le quita al <html> la clase
         rk-cod-oculto, que es del tema, no suya. */
      /* EL FORMULARIO SE ABRE COMO MODAL, igual que en la ficha.
         Antes se revelaba donde Releasit lo hubiera dejado, que en el carro es
         el final de la pagina, por debajo del riel de recomendados: el cliente
         pulsaba "continuar" y le aparecia un bloque suelto abajo del todo.
         El contenedor es el mismo que en la ficha, asi que el CSS del modal ya
         escrito le vale sin tocar nada. */
      var xCarro = null;
      var cerrarModalCarro = function(){
        raizC.classList.remove('rk-cod-carro-abierto');
        raizC.classList.add('rk-cod-oculto');
        document.documentElement.style.overflow = '';
        if(xCarro && xCarro.parentNode){ xCarro.parentNode.removeChild(xCarro); }
        xCarro = null;
      };

      /* CARRO CAMBIADO DESPUES DEL RENDER.

         Releasit pinta su formulario UNA sola vez, al cargar la pagina. Si el
         cliente sube una cantidad y despues pide pagar, el formulario manda el
         pedido viejo: medido, carro real $69.800 con dos unidades y formulario
         pidiendo una sola a $34.900. Eso no es un desajuste visual, es un
         pedido equivocado saliendo a la calle.

         DOS INTENTOS FALLIDOS ANTES DE ESTE, para que no se repitan:
         1. Fiarse de repintarCifras. Depende de que Dawn publique cartUpdate
            CON su cartData; cuando no lo trae cae a un fetch que puede fallar.
         2. Un MutationObserver sobre #main-cart-items. Dawn no muta ese nodo:
            lo DESTRUYE y lo vuelve a crear al re-renderizar la seccion, asi
            que el observador quedaba colgado de un elemento muerto y no se
            enteraba de nada. Verificado en vivo: cero recargas.

         LO QUE SI FUNCIONA: no guardar referencias a nodos ni escuchar
         eventos. Se anota cuantas unidades habia cuando la pagina se pinto y
         se vuelve a leer la insignia EN EL MOMENTO DEL CLIC. Si el numero
         cambio, el formulario esta caduco. La insignia la actualiza Dawn y se
         consulta de nuevo cada vez, asi que da igual que la reemplace. */
      /* TERCER INTENTO FALLIDO, anotado para que nadie lo repita: la insignia
         del carro NO sirve como señal. Esta documentado en el proyecto que se
         congela, porque el tema tiene dos canales que no se hablan (rk:carro y
         cartUpdate). Se leyo 1 al pintar y seguia diciendo 1 con dos unidades
         en el carro, asi que la comparacion nunca detectaba nada.

         LO QUE SI SE ACTUALIZA es el subtotal que pinta Dawn en /cart: lo
         vuelve a renderizar en cada cambio de cantidad. Medido: pasa de
         $34.900 a $69.800 al pulsar el mas. Se guarda su texto al cargar y se
         vuelve a leer en el clic. Fuera de /cart ese nodo no existe, los dos
         valores son nulos y no se dispara ninguna recarga de mas. */
      var subtotalAhora = function(){
        var t = document.querySelector('.totals__subtotal-value, .totals__total-value');
        if(!t){ return null; }
        var n = (t.textContent || '').replace(/[^0-9]/g, '');
        return n.length ? n : null;
      };
      var subtotalAlRender = subtotalAhora();
      var carroCambio = false;

      boton.addEventListener('click', function(ev){
        if(modoActual !== 'cod'){ return; }
        ev.preventDefault();

        /* EL FORMULARIO NO PUEDE ABRIRSE CON UN CARRO CADUCO.
           Releasit pinta su formulario UNA sola vez, al cargar la pagina. Si
           el cliente cambia una cantidad y despues pulsa aqui, el formulario
           sigue pidiendo lo de antes: se reprodujo con el carro real en
           $108.600 mientras el formulario pedia $52.800 y una sola unidad.
           Eso no es un desajuste visual, es un pedido equivocado saliendo a
           la calle. Si el carro cambio despues del render, se recarga y se
           deja la marca que rk-oferta.js ya usa para volver a pulsar este
           mismo boton al llegar. */
        var sub = subtotalAhora();
        var caduco = carroCambio ||
          (subtotalAlRender !== null && sub !== null && sub !== subtotalAlRender);
        if(caduco){
          try { sessionStorage.setItem('rk.of.abrirCod', '1'); } catch(e){}
          window.location.reload();
          return;
        }
        /* Salida propia. Releasit no siempre pinta la suya, y un modal a
           pantalla completa sin salida es una trampa en el telefono. Se cuelga
           de <body>, no de su contenedor. */
        if(!xCarro){
          xCarro = document.createElement('button');
          xCarro.type = 'button';
          xCarro.className = 'rk-cod-x';
          xCarro.setAttribute('aria-label', 'Cerrar');
          xCarro.textContent = '\u00D7';
          xCarro.addEventListener('click', cerrarModalCarro);
          document.body.appendChild(xCarro);
        }
        raizC.classList.remove('rk-cod-oculto');
        raizC.classList.add('rk-cod-carro-abierto');
        document.documentElement.style.overflow = 'hidden';
      });

      document.addEventListener('keydown', function(ev){
        if(ev.key === 'Escape' && raizC.classList.contains('rk-cod-carro-abierto')){ cerrarModalCarro(); }
      });

      /* Clic en el velo: dentro del contenedor pero fuera del panel. */
      document.addEventListener('click', function(ev){
        if(!raizC.classList.contains('rk-cod-carro-abierto')){ return; }
        var t = ev.target;
        if(!t.closest){ return; }
        /* el velo del carro es #cart-wrapper, no el hook de la ficha */
        if(t.closest('#cart-wrapper') && !t.closest('#rsi_form_wrapper')){
          cerrarModalCarro();
        }
      });

      document.addEventListener('rk:modo', function(ev){
        var m = ev.detail && ev.detail.modo;
        pintarPago(m === 'pre' ? 'prepago' : 'cod', false);
      });

      /* Estado inicial: el modo global, no un valor fijo. El atributo del
         <html> lo escribe el script en linea de theme.liquid antes de pintar,
         asi que ya esta disponible aunque rk-global.js todavia no haya
         corrido: este archivo se carga primero. */

      /* ------------------------------------------------------------------
         LAS CIFRAS SE RECALCULAN CUANDO CAMBIA EL CARRO

         Dawn actualiza el carro por AJAX y vuelve a renderizar solo las
         secciones que enumera en getSectionsToRender: main-cart-items,
         main-cart-footer, la burbuja del icono y la region viva. Esta seccion
         no esta en esa lista, asi que al pulsar "+" en una fila las filas se
         actualizaban y el panel de decision se quedaba con el subtotal, el
         ahorro y los dos precios del momento en que se cargo la pagina.
         Medido el 21-08-2026: carro de 271.500, se pulsa "+", el total real
         pasa a 303.400 y el panel seguia mostrando 271.500 con un ahorro
         calculado sobre esa cifra vieja. El cliente decidia como pagar
         mirando un total que ya no era el suyo, y el boton lo llevaba a un
         checkout que cobraba el nuevo.

         No se resuelve metiendo la seccion en la lista de Dawn: eso
         reemplazaria el HTML del panel y con el los nodos a los que este
         bloque ya tiene referencia, dejando la eleccion de pago sin
         manejadores. Se reescriben las cifras en su sitio, que ademas evita
         un reflujo del bloque entero.

         La fuente es cartData del propio evento de Dawn, que ya trae el
         estado nuevo; solo si no viniera se pide /cart.js. */
      var repintarCifras = function(datos){
        carroCambio = true;
        /* La base del 10% es items_subtotal_price y no total_price: este
           ultimo ya trae PAGOAHORA aplicado en cuanto el codigo queda pegado
           al carro, y calcular sobre el descontaba dos veces. Se comprobo en
           vivo: el panel prometia $48.438 y el pago cobraba $53.820. */
        if(!datos || typeof datos.items_subtotal_price !== 'number'){ return; }

        /* Carro vacio: esta seccion se imprimio bajo cart.item_count > 0, asi
           que su marcado entero ya no corresponde. Reescribir cifras sobre un
           panel que no deberia existir es peor que recargar. */
        if(datos.item_count === 0){ window.location.reload(); return; }

        var pct    = parseInt(carro.getAttribute('data-rk-dcto'), 10);
        if(isNaN(pct)){ pct = 10; }
        var total  = datos.items_subtotal_price;
        var neto   = Math.round(total * (100 - pct) / 100);
        var ahorro = total - neto;

        var sub = carro.querySelector('[data-cent-cod][data-cent-pre]');
        if(sub){
          sub.setAttribute('data-cod', monto(total));
          sub.setAttribute('data-pre', monto(neto));
          /* Los data-cent-* llevan CENTAVOS crudos a proposito: son el dato,
             no la vista. Quien los lea vuelve a pasarlos por monto(). */
          sub.setAttribute('data-cent-cod', total);
          sub.setAttribute('data-cent-pre', neto);
          sub.textContent = raizC.dataset.rkModo === 'pre' ? monto(neto) : monto(total);
        }

        var val = carro.querySelector('.rk-carro-ahorro__val');
        if(val){
          /* Se suelta el ancho que el contador congelo para la cifra anterior:
             si el ahorro nuevo es mas largo, quedaria recortado contra un
             minimo calculado para otro numero. */
          val.style.minWidth = '';
          val.setAttribute('data-rk-contar', ahorro);
          val.textContent = monto(ahorro);
        }

        var sello = carro.querySelector('.rk-opt__sello');
        if(sello){ sello.textContent = 'ahorras ' + monto(ahorro); }

        var pPre = carro.querySelector('[data-rk-opt="prepago"] .rk-opt__precio');
        if(pPre){ pPre.textContent = monto(neto); }
        var pCod = carro.querySelector('[data-rk-opt="cod"] .rk-opt__precio');
        if(pCod){ pCod.textContent = monto(total); }

        /* El boton lleva sus dos etiquetas en atributos y pintarPago las copia
           al DOM, asi que primero se actualizan los atributos y despues se
           repinta con la opcion que el cliente ya tenia elegida. */
        boton.setAttribute('data-rk-texto-prepago', 'Ir a pagar ' + monto(neto));
        boton.setAttribute('data-rk-sub-prepago', 'Con tarjeta, ahorras ' + monto(ahorro));
        boton.setAttribute('data-rk-sub-cod', monto(total) + ', pagas cuando lo recibes');

        var elegida = carro.querySelector('.rk-opt.is-elegida');
        pintarPago(elegida ? elegida.getAttribute('data-rk-opt') : 'cod', false);
      };

      if(typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.cartUpdate){
        subscribe(PUB_SUB_EVENTS.cartUpdate, function(ev){
          if(ev && ev.cartData){ repintarCifras(ev.cartData); return; }
          fetch('/cart.js').then(function(r){ return r.json(); }).then(repintarCifras).catch(function(){});
        });
      }

      pintarPago(raizC.dataset.rkModo === 'pre' ? 'prepago' : 'cod', false);
    }
  }

  /* ---------- 4b. carro con solo pago en linea ----------
     Con el ajuste "Solo pago en linea" el cierre del carro es un subtotal y un
     boton a /checkout, sin eleccion de pago. El bloque 4 no corre ahi (no hay
     opciones que elegir), asi que nadie actualizaba esas dos cifras cuando el
     cliente cambia una cantidad: Dawn re-renderiza la lista, pero no esta
     seccion. Aca se reescriben con el carro que publica Dawn, y si el carro
     queda vacio se recarga, porque la seccion entera ya no corresponde. */
  (function(){
    var carroSolo = document.querySelector('[data-rk-carro-solo]');
    if(!carroSolo){ return; }
    var sub = carroSolo.querySelector('[data-rk-solo-subtotal]');
    var ir  = carroSolo.querySelector('[data-rk-solo-ir]');
    var pintarSolo = function(datos){
      if(!datos || typeof datos.items_subtotal_price !== 'number'){ return; }
      if(datos.item_count === 0){ window.location.reload(); return; }
      var t = monto(datos.items_subtotal_price);
      if(sub){ sub.textContent = t; }
      if(ir){ ir.textContent = 'Ir a pagar ' + t; }
    };
    var pedir = function(){
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r){ return r.json(); }).then(pintarSolo).catch(function(){});
    };
    if(typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.cartUpdate){
      subscribe(PUB_SUB_EVENTS.cartUpdate, function(ev){
        if(ev && ev.cartData && typeof ev.cartData.items_subtotal_price === 'number'){ pintarSolo(ev.cartData); return; }
        pedir();
      });
    }
    document.addEventListener('rk:carro', pedir);
  })();

  /* ---------- 5. corte horario de despacho ----------
     Deliberadamente NO se calcula en Liquid. Shopify cachea el HTML de la
     ficha, asi que la hora quedaria congelada en el momento del render y el
     sitio podria prometer "despachamos hoy" a las once de la noche. Aca se
     resuelve en el navegador, contra la hora real de Santiago, y el parrafo
     nace oculto: si algo falla, no se muestra ninguna promesa en vez de
     mostrar una falsa.

     La hora de Santiago se obtiene con Intl y no con la hora local del
     visitante: un cliente conectado desde otro huso veria un corte que no
     corresponde a la bodega.

     TODOS los que haya, no el primero: la portada monta rk-reglas dos veces
     y el segundo parrafo nacia con hidden y no se revelaba nunca, quedando
     como un hueco vacio permanente. El chip de la barra de anuncio es otro
     elemento ([data-rk-corte-chip]) y lo resuelve rk-global.js; cada uno
     lleva su propia hora de corte, asi que se lee dentro del bucle. */
  var cortes = document.querySelectorAll('[data-rk-corte]');
  cortes.forEach(function(corte){
    try{
      var horaCorte = parseInt(corte.getAttribute('data-rk-corte'), 10) || 18;
      var partes = new Intl.DateTimeFormat('es-CL', {
        timeZone: 'America/Santiago', hour: 'numeric', weekday: 'short', hour12: false
      }).formatToParts(new Date());
      var h = 0, dia = '';
      partes.forEach(function(p){
        if(p.type === 'hour'){ h = parseInt(p.value, 10); }
        if(p.type === 'weekday'){ dia = p.value.toLowerCase(); }
      });
      var esFinde = dia.indexOf('sá') === 0 || dia.indexOf('sab') === 0 || dia.indexOf('dom') === 0;

      var mensaje;
      if(esFinde){
        mensaje = 'Pídelo ahora y lo despachamos el <b>lunes</b>';
      } else if(h < horaCorte){
        var faltan = horaCorte - h;
        mensaje = 'Pídelo dentro de <b>' + faltan + (faltan === 1 ? ' hora' : ' horas') + '</b> y lo despachamos hoy';
      } else {
        mensaje = 'Pídelo ahora y lo despachamos <b>mañana</b>';
      }
      corte.innerHTML = mensaje;
      corte.hidden = false;
    } catch(e){ /* sin promesa antes que una promesa equivocada */ }
  });

  /* ---------- 6. cifra que cuenta hacia arriba ----------
     El ahorro sube desde cero cuando entra en pantalla. El ancho ya esta
     reservado por CSS con cifras tabulares, asi que el conteo no reacomoda
     nada alrededor: sin eso, el numero creciendo empujaria el texto vecino en
     cada cuadro y dispararia el CLS justo en el elemento que mas importa.
     Con movimiento reducido se escribe el valor final de una vez. */
  var contadores = document.querySelectorAll('[data-rk-contar]');
  if(contadores.length){
    var animarCifra = function(el){
      /* SE ESPERA A LAS FUENTES ANTES DE MEDIR. El ancho se congela a partir
         de lo que Liquid ya imprimio, pero si en ese momento todavia esta la
         fuente de respaldo, lo que queda congelado es el ancho equivocado: la
         cifra nace atada a una medida que la fuente real no cumple y el texto
         vecino se reacomoda cuando Manrope llega. Ese era el CLS variable de
         la coleccion, que segun la pasada media 0,003 o 0,037 sin que el
         codigo cambiara: era una carrera entre la fuente y el observador.
         document.fonts.ready ya esta resuelto si la fuente venia en cache, o
         sea que en la visita repetida no retrasa nada. */
      if(document.fonts && document.fonts.ready && document.fonts.ready.then){
        document.fonts.ready.then(function(){ arrancarCifra(el); });
      } else {
        arrancarCifra(el);
      }
    };

    var arrancarCifra = function(el){
      if(el.dataset.rkContado === '1'){ return; }
      el.dataset.rkContado = '1';
      var destino = parseInt(el.getAttribute('data-rk-contar'), 10);
      if(!destino || destino < 0){ return; }
      /* Este es el sitio donde se elige entre las dos del bloque 0, y donde ya
         se eligio mal una vez.

         LA AUSENCIA DEL ATRIBUTO CAE DEL LADO INOFENSIVO, y esa es toda la
         gracia. Antes el defecto era monto(), o sea la rama que divide por
         cien: un contador nuevo copiado del patron de al lado, sin declarar su
         formato, imprimia "$1" donde debia decir "70". Es literalmente el
         fallo que este bloque documenta como ya ocurrido, a un atributo
         olvidado de volver. Ahora hay que pedir "monto" de forma explicita
         para que se divida; sin atributo no se toca el numero. El peor caso de
         un olvido pasa a ser una cifra sin signo de peso, que se ve rota, en
         vez de un precio cien veces menor, que se lee como precio. */
      var fmt = el.getAttribute('data-rk-contar-formato') === 'monto' ? monto : conteo;

      /* Se congela el ancho ANTES de tocar el texto. Liquid ya imprimio el
         valor final, asi que lo que se mide aca es exactamente el ancho que
         el numero va a ocupar al terminar. Sin esto la cifra crece de "$0" a
         "$56.000" y empuja el texto vecino en cada cuadro: el CLS de la ficha
         de escritorio medido asi era 0.078, y el elemento que se movia era
         justo el ahorro, o sea el argumento de venta. */
      var ancho = el.getBoundingClientRect().width;
      if(ancho > 0){ el.style.minWidth = Math.ceil(ancho) + 'px'; }

      if(reduce){ el.textContent = fmt(destino); return; }
      var inicio = null, dur = 900;
      var paso = function(t){
        if(inicio === null){ inicio = t; }
        var p = Math.min((t - inicio) / dur, 1);
        /* easeOutQuart: arranca rapido y frena, que es como se lee un total
           que se "resuelve", en vez de una cuenta mecanica lineal */
        var e = 1 - Math.pow(1 - p, 4);
        el.textContent = fmt(destino * e);
        if(p < 1){ requestAnimationFrame(paso); }
      };
      requestAnimationFrame(paso);
    };

    if(!('IntersectionObserver' in window)){
      contadores.forEach(function(el){ animarCifra(el); });
    } else {
      var ioC = new IntersectionObserver(function(entradas){
        entradas.forEach(function(en){
          if(en.isIntersecting){ animarCifra(en.target); ioC.unobserve(en.target); }
        });
      }, { threshold: .6 });
      contadores.forEach(function(el){ ioC.observe(el); });
    }
  }

  /* ---------- 7. agregar al carro sin recargar ----------
     El disparador es un ENLACE a /cart/add?id=..&quantity=1, no un formulario
     con boton de envio. La razon esta explicada en detalle en
     sections/rk-producto.liquid: Releasit tiene activado hideAddToCartButton
     e inyecta una regla que oculta cualquier button[type=submit] dentro de un
     formulario que apunte a /cart/add. Nuestro boton caia ahi y quedaba con
     display:none y ancho cero.

     Sin JavaScript el enlace funciona solo: /cart/add acepta GET, agrega el
     producto y aterriza en el carro. Con JavaScript se evita el salto de
     pagina, que en movil dentro del navegador de Instagram es donde mas
     gente se pierde.

     A PRUEBA DE FALLOS: ante cualquier error se deja seguir la navegacion
     normal del enlace en vez de tragarse el clic.

     TODOS los enlaces, no el primero. Hoy emiten el marcador cuatro sitios:
     el bloque de compra y cada tarjeta del cross-sell en
     sections/rk-producto.liquid, el riel movil en sections/rk-riel.liquid y
     el boton de agregado rapido de la tarjeta de catalogo en
     snippets/rk-card-producto.liquid. Con
     querySelector solo el primero agregaba sin recargar y los demas se
     comportaban como enlaces pelados, que en el navegador de Instagram es
     justo donde se pierde la sesion. El estado "ya agregado" es de cada
     enlace, asi que vive dentro del bucle. */
  var lnksAdd = document.querySelectorAll('[data-rk-agregar]');
  if(lnksAdd.length && window.fetch){
    lnksAdd.forEach(function(lnkAdd){
      var txtAdd = lnkAdd.querySelector('[data-rk-add-txt]');
      var yaAgregado = false;

      lnkAdd.addEventListener('click', function(ev){
        if(!txtAdd){ return; }

        /* segundo clic, ya agregado: al carro */
        if(yaAgregado){
          ev.preventDefault();
          window.location.href = '/cart';
          return;
        }

        ev.preventDefault();
        var original = txtAdd.textContent;
        var vid = parseInt(lnkAdd.getAttribute('data-rk-var'), 10);
        if(!vid){ window.location.href = lnkAdd.getAttribute('href'); return; }

        lnkAdd.setAttribute('aria-busy', 'true');
        txtAdd.textContent = 'Agregando...';

        /* _RK_ORIGEN, SOLO SI EL PROPIO ENLACE LO PIDE (15-09-2026).
           "agregue dos productos y solo a uno le puso el descuento". El
           complemento que se agrega sin este aviso cae de vuelta al bucle
           de "producto promo" de la funcion de descuentos (ver rk-app-
           descuentos, regla 5) si el producto tambien tiene su propio
           "Promo por pack" — que es el caso de los 6 suplementos propios:
           con 1 sola unidad ese bucle no aplica ningun descuento, y el
           40% de complemento que la tarjeta prometia no se cobraba.
           snippets/rk-cross-sell.liquid ("Combínalo con" en la ficha Y el
           mismo bloque que se repite en la pagina del carro) es el unico
           que ahora marca su enlace con data-rk-origen="complemento": es
           el unico de los tres usos de este mismo boton (el otro es el
           agregado rapido de la tarjeta de catalogo, sections/rk-card-
           producto.liquid) donde la intencion real es "complemento de
           otro producto" y no "quiero este producto por si mismo". El
           carrusel de complementos de la propia ficha (snippets/rk-packs)
           ya escribia esta misma propiedad por su cuenta, mas abajo en
           este archivo — esto solo le agrega el mismo aviso al OTRO
           camino de agregar un complemento que existia sin el. */
        var origenLnk = lnkAdd.getAttribute('data-rk-origen');
        var itemAdd = { id: vid, quantity: 1 };
        if(origenLnk){ itemAdd.properties = { _rk_origen: origenLnk }; }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [itemAdd] })
        })
        .then(function(r){ if(!r.ok){ throw new Error('add'); } return r.json(); })
        .then(function(){ return fetch('/cart.js').then(function(r){ return r.json(); }); })
        .then(function(c){
          /* NO se escribe la insignia aqui. Se hacia, con otro selector, sobre
             el mismo <b> que repinta rk-global.js al oir rk:carro: dos
             escritores para un dato. Y el de aqui escribia solo el numero, sin
             tocar data-vacio, que es el atributo que decide si la insignia se
             ve: rk-global.css la oculta mientras valga "1". Con rk-global.js
             caido, el acuse de recibo quedaba invisible con el numero correcto
             adentro. Un solo escritor, el que escucha el evento. */
          /* el mismo aviso que ya escucha el contador del encabezado en
             rk-global.js, para que el badge salte tambien cuando el agregado
             sale de una tarjeta o del riel y no solo de la ficha */
          document.dispatchEvent(new CustomEvent('rk:carro', { detail: { count: c.item_count } }));
          /* Y ademas se avisa por el canal de Dawn. En la propia pagina del
             carro hay un cross-sell con este mismo boton, y agregar desde
             ahi cambia el total sin pasar por el codigo de Dawn: sin este
             aviso, el panel de decision se quedaba con las cifras de antes,
             que es el mismo desfase que produce el boton de cantidad.
             Se publica el estado real que acaba de devolver /cart.js. */
          if(typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.cartUpdate){
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rk-agregar', cartData: c });
          }
          txtAdd.textContent = 'Agregado. Ver el carro';
          lnkAdd.removeAttribute('aria-busy');
          /* La tarjeta de catalogo trae aria-label ("Agregar tal cosa al
             carro") porque en una rejilla "Agregar" a secas no dice que
             producto. Ese nombre accesible le gana al texto visible, asi que
             al cambiar el enlace a "Ver el carro" hay que soltarlo o el
             lector de pantalla seguiria ofreciendo agregar. Donde no hay
             aria-label —ficha, cross-sell, riel— esto no hace nada. */
          lnkAdd.removeAttribute('aria-label');
          lnkAdd.setAttribute('href', '/cart');
          yaAgregado = true;
        })
        .catch(function(){
          /* si algo falla se sigue el enlace de verdad: el cliente termina en
             el carro igual, nunca con un boton muerto */
          txtAdd.textContent = original;
          lnkAdd.removeAttribute('aria-busy');
          window.location.href = lnkAdd.getAttribute('href');
        });
      });
    });
  }

  /* ---------- 8. riel movil al salir el hero ----------
     El riel existe desde antes, pero estaba visible siempre. Mostrarlo
     tapando el CTA del hero es competir contra uno mismo: mientras el bloque
     de compra esta en pantalla el riel sobra, y recien cuando sale hace
     falta. Se observa el hero y se conmuta. */
  /* Se observa el GRUPO DE BOTONES, no todo el hero. Observando el hero
     entero (galeria mas decision) el riel desaparecia unos 1.800 px de
     recorrido; observando solo los botones se aparta unos 300 px, que es
     exactamente la franja en la que estorba. Con respaldo al hero por si
     el selector cambiara. */
  var heroPdp = document.querySelector('.rk-pdp__decision .rk-ctas') ||
                document.querySelector('[data-rk-hero]');
  var rielPdp = document.querySelector('.rk-riel');
  if(heroPdp && rielPdp && 'IntersectionObserver' in window){
    rielPdp.classList.add('rk-riel--auto');
    var ioR = new IntersectionObserver(function(entradas){
      entradas.forEach(function(en){
        rielPdp.classList.toggle('is-fuera', !en.isIntersecting);
      });
    }, { rootMargin: '-120px 0px 0px 0px' });
    ioR.observe(heroPdp);
  }

  /* ---------- 9. capa de movimiento (Fase 2.4) ----------
     Cuatro comportamientos, todos condicionados a que el visitante NO haya
     pedido movimiento reducido. Si lo pidio, este bloque entero no corre y
     el contenido nace visible: nada se queda escondido esperando una
     animacion que nunca va a ocurrir.

     Solo se animan transform y opacity, las dos propiedades que el
     compositor resuelve sin recalcular layout ni repintar. Nada de width,
     height, top ni left.

     C1 revelado por seccion, una sola vez, con escalonado entre hijos
     C2 cifras de specs heroe que cuentan al entrar
     C3 flotacion del producto en el hero
     C4 cambio a la segunda foto en las tarjetas de catalogo

     PROHIBIDO por la direccion y no implementado: zoom automatico tipo Ken
     Burns, carruseles que avanzan solos, parallax. */
  if(!reduce){

    /* ---- C1 · revelado al entrar, una sola vez ----
       El escalonado se aplica como retardo por indice sobre los hijos
       marcados, no con un temporizador por elemento: asi el navegador
       agrupa todo en la misma pasada de composicion. */
    var seccionesRv = document.querySelectorAll('[data-rk-rv]');
    if(seccionesRv.length && 'IntersectionObserver' in window){
      seccionesRv.forEach(function(sec){
        sec.classList.add('rk-mv');
        var hijos = sec.querySelectorAll('[data-rk-rv-hijo]');
        hijos.forEach(function(h, i){
          h.classList.add('rk-mv-hijo');
          h.style.transitionDelay = (i * 80) + 'ms';
        });
      });
      var ioMv = new IntersectionObserver(function(entradas){
        entradas.forEach(function(en){
          if(!en.isIntersecting) return;
          en.target.classList.add('rk-mv-in');
          ioMv.unobserve(en.target);
          /* el retardo se limpia despues de entrar: si no, cualquier
             transicion posterior del mismo elemento (un hover, por ejemplo)
             arrastraria esos 80ms de mas y se sentiria pegajosa */
          var hs = en.target.querySelectorAll('[data-rk-rv-hijo]');
          setTimeout(function(){
            hs.forEach(function(h){ h.style.transitionDelay = ''; });
          }, 400 + hs.length * 80);
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
      seccionesRv.forEach(function(s){ ioMv.observe(s); });
    }

    /* ---- C2 · cifras de specs que cuentan al entrar ----
       Solo se anima la parte numerica. Un valor como "3x + 3x" o "300°"
       lleva texto pegado, asi que se separa el numero inicial, se cuenta, y
       el resto se vuelve a pegar tal cual. Si la cifra no empieza por un
       numero se deja quieta: contar "Wi-Fi" no significa nada. */
    var stats = document.querySelectorAll('[data-rk-stat]');
    if(stats.length && 'IntersectionObserver' in window){
      var animarStat = function(el){
        var full = el.getAttribute('data-rk-stat') || el.textContent;
        var m = full.match(/^(\d+)(.*)$/);
        if(!m){ return; }
        var destino = parseInt(m[1], 10), cola = m[2];
        /* el ancho ya esta reservado por min-height y cifras tabulares en
           CSS, pero se fija tambien el ancho medido para que el conteo no
           mueva a los vecinos horizontalmente */
        var w = el.getBoundingClientRect().width;
        if(w > 0){ el.style.minWidth = Math.ceil(w) + 'px'; }
        var t0 = null, dur = 1000;
        var paso = function(t){
          if(t0 === null){ t0 = t; }
          var p = Math.min((t - t0) / dur, 1);
          var e = 1 - Math.pow(1 - p, 4);
          el.textContent = Math.round(destino * e) + cola;
          if(p < 1){ requestAnimationFrame(paso); }
        };
        el.textContent = '0' + cola;
        requestAnimationFrame(paso);
      };
      var ioSt = new IntersectionObserver(function(entradas){
        entradas.forEach(function(en){
          if(en.isIntersecting){ animarStat(en.target); ioSt.unobserve(en.target); }
        });
      }, { threshold: 0.6 });
      stats.forEach(function(s){ ioSt.observe(s); });
    }

    /* ---- C3 · flotacion del producto en el hero ----
       Se marca por clase y la animacion vive en CSS. Amplitud de 5px y
       ciclo de 8s: por debajo del umbral de "esto se esta moviendo" y por
       encima del de "esto es una imagen muerta". Solo en la ficha, y solo
       en la foto activa. */
    var heroEsc = document.querySelector('[data-rk-hero] .rk-gal__slide.is-active .rk-esc__placa');
    if(heroEsc){ heroEsc.classList.add('rk-flota'); }

    /* ---- C4 · segunda foto al pasar el cursor en el catalogo ----
       Solo en tarjetas con dos o mas fotos y solo donde hay cursor real:
       en tactil no existe hover, y un "pseudo-hover" al tocar dejaria la
       tarjeta cambiada hasta que el dedo toque otra cosa.
       La segunda imagen se crea al vuelo y nace con loading lazy, asi que
       no compite con la carga inicial de la rejilla. */
    if(window.matchMedia('(hover: hover) and (pointer: fine)').matches){
      document.querySelectorAll('.rk-card[data-rk-foto2]').forEach(function(card){
        var placa = card.querySelector('.rk-esc__placa');
        if(!placa || placa.querySelector('[data-rk-img2]')) return;
        var url = card.getAttribute('data-rk-foto2');
        if(!url) return;
        var img2 = document.createElement('img');
        img2.src = url;
        img2.alt = '';
        img2.loading = 'lazy';
        img2.setAttribute('data-rk-img2', '');
        img2.className = 'rk-esc__img2';
        placa.appendChild(img2);
      });
    }
  }

  /* ---------- 1. revelado heredado ----------
     Lo reemplaza el bloque 9 (C1), que ademas escalona los hijos. Se
     conserva porque secciones antiguas del home todavia usan
     data-rk-rv sin hijos marcados, y sin esto quedarian invisibles. */
  var els = document.querySelectorAll('[data-rk-rv]');
  if(els.length){
    if(reduce || !('IntersectionObserver' in window)){
      els.forEach(function(el){ el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px' });
      els.forEach(function(el){ io.observe(el); });
    }
  }

  /* ---------- 1b. video de demostracion ----------
     El <video> llega del servidor SIN src, solo con data-rk-demo-src. Aca se
     le pone el src recien cuando el bloque se acerca a la pantalla, con 300 px
     de anticipacion para que alcance a cargar antes de que se vea.

     Por que asi y no con preload="none" a secas: preload es una sugerencia y
     hay navegadores que igual se traen los primeros segundos. Un elemento sin
     src no tiene nada que traerse, y esa es la unica garantia de verdad de que
     este video no pesa en la carga inicial de la ficha.

     Con movimiento reducido no se reproduce solo: queda el poster y el boton,
     y arranca unicamente si la persona lo pide. */
  (function(){
    var caja = document.querySelector('.rk-demo-v');
    if(!caja) { return; }
    var vid = caja.querySelector('[data-rk-demo-src]');
    var play = caja.querySelector('[data-rk-demo-play]');
    if(!vid) { return; }
    var cargado = false;

    var cargar = function(){
      if(cargado) { return; }
      cargado = true;
      vid.src = vid.getAttribute('data-rk-demo-src');
      vid.load();
    };
    var arrancar = function(){
      cargar();
      var p = vid.play();
      if(p && p.then) { p.then(function(){ caja.classList.add('is-andando'); }, function(){}); }
      else { caja.classList.add('is-andando'); }
    };

    vid.addEventListener('playing', function(){ caja.classList.add('is-andando'); });
    vid.addEventListener('pause',   function(){ caja.classList.remove('is-andando'); });
    if(play) { play.addEventListener('click', arrancar); }
    /* tocar el video lo pausa y lo reanuda, que es lo que la gente espera */
    vid.addEventListener('click', function(){
      if(vid.paused) { arrancar(); } else { vid.pause(); }
    });

    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(ents){
        ents.forEach(function(en){
          if(!en.isIntersecting) {
            if(cargado && !vid.paused) { vid.pause(); }   /* fuera de pantalla no gasta */
            return;
          }
          if(reduce) { cargar(); return; }
          arrancar();
        });
      }, { rootMargin: '300px 0px' });
      io.observe(caja);
    } else {
      /* sin soporte, se carga al pulsar y nada mas */
      cargar();
    }
  }());

  /* ---------- 1d. fechas de la linea de entrega ----------
     Se calculan aqui y no en Liquid porque Shopify cachea el HTML: una fecha
     escrita al renderizar quedaria congelada y la ficha podria prometer "llega
     el martes" un viernes.

     Todo se resuelve contra la hora de SANTIAGO, que es donde esta la bodega,
     no contra la del visitante.

     LOS FERIADOS SON PARTE DEL CALCULO. Sin ellos, un pedido del 17 de
     septiembre prometeria entrega el 18, que es feriado irrenunciable y no
     despacha nadie. La lista es de feriados legales de Chile y HAY QUE
     ACTUALIZARLA cada año; si se vence, el calculo sigue funcionando y solo
     pierde precision en esos dias puntuales.

     Se muestran RANGOS y no una fecha unica: no sabemos desde donde compra
     quien esta mirando, y en Chile una fecha prometida en la ficha es
     exigible. */
  (function () {
    var caja = document.querySelector('[data-rk-entrega]');
    if (!caja) { return; }
    var corte = parseInt(caja.getAttribute('data-rk-entrega-corte'), 10) || 18;

    /* feriados legales de Chile. Actualizar cada año. */
    var FERIADOS = [
      '2026-01-01','2026-04-03','2026-04-04','2026-05-01','2026-05-21',
      '2026-06-21','2026-06-29','2026-07-16','2026-08-15','2026-09-18',
      '2026-09-19','2026-10-12','2026-10-31','2026-11-01','2026-12-08','2026-12-25',
      '2027-01-01','2027-03-26','2027-03-27','2027-05-01','2027-05-21',
      '2027-06-21','2027-06-28','2027-07-16','2027-08-15','2027-09-18',
      '2027-09-19','2027-10-11','2027-10-31','2027-11-01','2027-12-08','2027-12-25'
    ];
    var iso = function (d) {
      return d.getFullYear() + '-' +
        ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
    };
    var habil = function (d) {
      var s = d.getDay();
      if (s === 0 || s === 6) { return false; }
      return FERIADOS.indexOf(iso(d)) < 0;
    };
    var sumarHabiles = function (d, n) {
      var x = new Date(d.getTime());
      var i = 0;
      while (i < n) { x.setDate(x.getDate() + 1); if (habil(x)) { i++; } }
      return x;
    };
    var texto = function (d) {
      try {
        return new Intl.DateTimeFormat('es-CL', { day: 'numeric', month: 'short', timeZone: 'America/Santiago' })
          .format(d).replace('.', '');
      } catch (e) { return ''; }
    };

    var pintar = function () {
      try {
        /* hoy, en hora de Santiago */
        var p = new Intl.DateTimeFormat('en-CA', {
          timeZone: 'America/Santiago', year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', hour12: false
        }).formatToParts(new Date());
        var v = {};
        p.forEach(function (x) { v[x.type] = x.value; });
        var hoy = new Date(Number(v.year), Number(v.month) - 1, Number(v.day));
        var h = Number(v.hour);

        /* el pedido sale hoy si es habil y aun no paso el corte */
        var sale = new Date(hoy.getTime());
        if (!habil(sale) || h >= corte) { sale = sumarHabiles(sale, 1); }

        var e1 = caja.querySelector('[data-rk-entrega-h1]'),
            e2 = caja.querySelector('[data-rk-entrega-h2]'),
            e3 = caja.querySelector('[data-rk-entrega-h3]'),
            cab = caja.querySelector('[data-rk-entrega-cabeza]');

        var mismoDia = iso(sale) === iso(hoy);
        if (e1) { e1.textContent = mismoDia ? 'Hoy' : texto(sale); }
        if (e2) { e2.textContent = texto(sale); }
        /* El hito muestra el rango de SANTIAGO, 1 a 3 habiles, que es de
           donde viene la mayor parte del trafico. El de regiones queda en el
           pie, rotulado. Antes se mostraba el rango completo de 1 a 5 y
           cruzando el 18 de septiembre daba "15 sept a 22 sept": siete dias,
           correcto pero leido como una promesa floja. */
        if (e3) { e3.textContent = texto(sumarHabiles(sale, 1)) + ' a ' + texto(sumarHabiles(sale, 3)); }

        if (cab && mismoDia) {
          var falta = (corte - h) * 60;
          var mm = Number(new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Santiago', minute: '2-digit' }).format(new Date()));
          falta = falta - mm;
          if (falta > 0) {
            var hh = Math.floor(falta / 60), m2 = falta % 60;
            cab.textContent = 'Pide dentro de ' + hh + ' h ' + ('0' + m2).slice(-2) + ' min y sale hoy';
          }
        }
      } catch (e) {
        /* se queda el texto de respaldo del marcado: nunca una fecha inventada */
      }
    };

    pintar();
    setInterval(pintar, 60000);
  }());

  /* ---------- 1c. packs, complementos y resumen del pedido ----------
     Elegir un pack o marcar complementos cambia el resumen (filas, ahorro y
     total), la cifra del boton y la del riel movil. El precio grande de
     arriba no se toca: es el ancla con la que el cliente llego desde el
     anuncio.

     LAS CUENTAS NO SE INVENTAN ACA. Cada tarjeta trae desde Liquid lo que
     cobra (data-cent) y lo que costaria sin descuento (data-cent-lista), ya
     calculado con las mismas reglas que la funcion de descuento de la app,
     que es la que cobra. Aca solo se suma.

     EL FORMATO TAMPOCO SE ADIVINA: se lee de una cifra real impresa por
     Liquid en la misma pagina (data-rk-packs-formato) y se copian su prefijo
     y su separador de miles, para que lo que escribe el navegador sea
     identico a lo que imprimio el servidor.

     TOPE DE COMPLEMENTOS. Con el tope alcanzado, las casillas que quedan se
     bloquean y se dice por que. La funcion aplica el mismo tope, asi que aun
     si alguien lo saltara, el checkout no regala una cuarta unidad.

     AL ENVIAR, el carro queda EXACTAMENTE como se eligio, no se suma: volver
     atras y apretar otra vez no termina en seis unidades.
       - el producto: su linea queda con la cantidad del pack
       - los complementos que puso este bloque llevan la propiedad oculta
         _rk_origen; si el cliente los desmarco, se sacan. Lo que entro al
         carro por otro camino no se toca.
     Despues se sale por el enlace de pago del bloque (ver rk-packs.liquid). */
  (function () {
    var form = document.querySelector('[data-rk-packs]');
    if (!form) { return; }
    var todos = function (sel) { return Array.prototype.slice.call(form.querySelectorAll(sel)); };
    /* LOS COMPLEMENTOS YA NO VIVEN DENTRO DEL <form> (16-09-2026). Se movieron
       a snippets/rk-complementos.liquid, que la seccion imprime a ancho
       completo debajo del bloque de compra — fuera del formulario, entonces
       "todos()" (que busca dentro del form) ya no los encuentra. Todo lo que
       sea del bloque de complementos pasa a buscarse en el documento. Que las
       casillas queden fuera del <form> no cambia lo que viaja al carro: este
       formulario se envia por fetch armando el payload a mano, nunca por
       submit nativo. */
    var todosDoc = function (sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); };
    var raizUrl = function () {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    };
    var packs = todos('[data-rk-pack]'),
        comps = todosDoc('[data-rk-comp]'),
        caja  = document.querySelector('[data-rk-comps]'),
        TOPE  = caja ? (parseInt(caja.getAttribute('data-rk-tope'), 10) || 3) : 3,
        /* EL RESUMEN "TU PEDIDO" YA NO VIVE DENTRO DEL <form> (16-09-2026).
           Se movio a snippets/rk-pedido.liquid, que la seccion imprime como
           fila propia a ancho completo debajo de los complementarios. Sus
           nodos pasan a buscarse en el DOCUMENTO; si se dejaban con
           form.querySelector volvian null y pintar() dejaba de escribir
           total, ahorro y cantidades: el bloque se quedaba congelado en la
           cifra de Liquid. Es el mismo estado y la misma funcion, solo
           cambia donde estan los nodos que pinta. */
        elTot = document.querySelector('[data-rk-packs-total]'),
        elAho = document.querySelector('[data-rk-packs-ahorro]'),
        filaAho = document.querySelector('[data-rk-res-fila-ahorro]'),
        elCta = form.querySelector('[data-rk-packs-cta-total]'),
        cta   = form.querySelector('[data-rk-packs-cta]'),
        falla = form.querySelector('[data-rk-packs-falla]'),
        ctaPedido = document.querySelector('[data-rk-pedido-cta]'),
        elCtaPedido = document.querySelector('[data-rk-pedido-cta-total]'),
        pedidoCuenta = document.querySelector('[data-rk-pedido-cuenta]'),
        cuenta = document.querySelector('[data-rk-comps-cuenta]'),
        elegidosTx = document.querySelector('[data-rk-comps-elegidos]'),
        aviso = document.querySelector('[data-rk-comps-tope]'),
        resN  = document.querySelector('[data-rk-res-n]'),
        resTot = document.querySelector('[data-rk-res-total]'),
        resAntes = document.querySelector('[data-rk-res-antes]'),
        upd   = form.querySelector('[data-rk-packs-upd]'),
        ir    = form.querySelector('[data-rk-packs-ir]'),
        varId = form.getAttribute('data-rk-packs-var'),
        ref   = form.querySelector('[data-rk-packs-formato]'),
        rielCifra = document.querySelector('.rk-riel__op--unico .rk-riel__cifra');

    /* el formato, leido de una cifra real de Liquid: 123456700 centavos */
    var muestra = ref ? ref.getAttribute('data-rk-packs-formato') : '$1.234.567';
    var prefijo = (muestra.match(/^[^0-9]*/) || [''])[0];
    var sufijo  = (muestra.match(/[^0-9]*$/) || [''])[0];
    var cuerpo  = muestra.slice(prefijo.length, muestra.length - sufijo.length);
    var sep = (cuerpo.match(/[^0-9]/) || ['.'])[0];
    var dinero = function (cent) {
      var p = String(Math.round(cent / 100));
      return prefijo + p.replace(/\B(?=(\d{3})+(?!\d))/g, sep) + sufijo;
    };
    var cent = function (el, attr) { return parseInt(el.getAttribute(attr), 10) || 0; };

    var elegido = packs.filter(function (p) { return p.classList.contains('is-elegido'); })[0] || packs[0];
    var visible = 0;

    var latir = function (el) {
      if (!el || reduce) { return; }
      el.classList.remove('is-cambiando'); void el.offsetWidth; el.classList.add('is-cambiando');
    };
    var casilla = function (c) { return c.querySelector('[data-rk-comp-check]'); };
    /* CANTIDAD POR COMPLEMENTO (14-09-2026): "con 1 unidad 40% dcto al
       complemento. si tiene pack de 3 o 6 puede obtenerlos al 50%". Cada
       tarjeta guarda su cantidad elegida (1, 3 o 6) en data-rk-comp-q, y su
       precio para cada una de esas tres en data-cent-1/3/6 (misma cuenta
       que ya hace la funcion de descuentos, ver rk-packs.liquid). qtyDe/
       centDe leen esos dos datos juntos: nunca hay una cantidad sin su
       precio correspondiente. */
    var qtyDe = function (c) { return parseInt(c.getAttribute('data-rk-comp-q'), 10) || 1; };
    var centDe = function (c, attr) { return cent(c, attr + '-' + qtyDe(c)); };
    var marcados = function () {
      return comps.filter(function (c) { var k = casilla(c); return !!(k && k.checked); });
    };
    var unidadesElegidas = function () {
      return marcados().reduce(function (acc, c) { return acc + qtyDe(c); }, 0);
    };

    /* EL TOPE TIENE QUE CONTAR EL CARRO, NO SOLO ESTE CARRUSEL  16-09-2026
       El tope existe porque la funcion de descuentos solo aplica el 40% a un
       numero limitado de unidades de complemento; lo que pasa de ahi se cobra
       entero. Pero se contaban unicamente las casillas de esta pagina. Si el
       cliente ya traia complementos de "Combinalo con" o del carro, la suma
       real se pasaba y parte de las unidades que esta pagina prometia con
       descuento se cobraban completas.
       Se leen una vez las lineas de complemento que YA estan en el carro y no
       nacieron de este carrusel; las que el cliente marque aca se descuentan
       de esa cuenta, porque al enviar el formulario esas lineas se
       sincronizan con la cantidad elegida aqui (ver el reconciliador).
       Si el carro no responde, ajenas queda en 0 y el tope se comporta como
       antes: nunca se bloquea la compra por no poder leerlo. */
    var lineasAjenas = [];
    var unidadesAjenas = function () {
      var marcadasAhora = {};
      marcados().forEach(function (c) { marcadasAhora[String(c.getAttribute('data-rk-comp-var'))] = true; });
      return lineasAjenas.reduce(function (acc, l) {
        return acc + (marcadasAhora[l.v] ? 0 : l.q);
      }, 0);
    };
    var topeLibre = function () { return Math.max(0, TOPE - unidadesAjenas()); };

    var pintarComp = function (c) {
      var q = qtyDe(c);
      var precioEl = c.querySelector('[data-rk-comp-precio]');
      var antesEl = c.querySelector('[data-rk-comp-antes]');
      var chipEl = c.querySelector('[data-rk-comp-chip]');
      var tot = centDe(c, 'data-cent');
      var lista = centDe(c, 'data-cent-lista');
      if (precioEl) { precioEl.textContent = dinero(tot); }
      if (antesEl) { antesEl.hidden = lista <= tot; if (lista > tot) { antesEl.textContent = dinero(lista); } }
      if (chipEl && !chipEl.hidden) {
        var pct = lista > 0 ? Math.round((1 - tot / lista) * 100) : 0;
        chipEl.textContent = pct + '% OFF';
      }
      c.querySelectorAll('[data-rk-comp-q-btn]').forEach(function (b) {
        b.classList.toggle('is-activo', parseInt(b.getAttribute('data-rk-comp-q-btn'), 10) === q);
      });
    };

    var pintar = function () {
      if (!elegido) { return; }
      var n = parseInt(elegido.getAttribute('data-n'), 10) || 1;
      var tot = cent(elegido, 'data-cent');
      var lista = cent(elegido, 'data-cent-lista') || tot;

      if (resN) { resN.textContent = n + ' ×'; }
      if (resTot) { resTot.textContent = dinero(tot); }
      if (resAntes) {
        resAntes.hidden = lista <= tot;
        resAntes.textContent = lista > tot ? dinero(lista) : '';
      }
      if (upd) { upd.value = String(n); }

      var sel = marcados();
      var unidadesSel = unidadesElegidas();
      comps.forEach(function (c) {
        var k = casilla(c);
        var on = !!(k && k.checked);
        var q = qtyDe(c);
        pintarComp(c);
        var fila = document.querySelector('[data-rk-res-comp="' + c.getAttribute('data-rk-comp-var') + '"]');
        if (fila) {
          fila.hidden = !on;
          if (on) {
            var filaCant = fila.querySelector('[data-rk-res-cant]');
            var filaPrecio = fila.querySelector('[data-rk-res-comp-precio]');
            var filaAntes = fila.querySelector('[data-rk-res-comp-antes]');
            var t = centDe(c, 'data-cent'), l = centDe(c, 'data-cent-lista');
            if (filaCant) { filaCant.textContent = q + ' ×'; }
            if (filaPrecio) { filaPrecio.textContent = dinero(t); }
            if (filaAntes) { filaAntes.hidden = l <= t; if (l > t) { filaAntes.textContent = dinero(l); } }
          }
        }
        if (on) {
          tot += centDe(c, 'data-cent');
          lista += centDe(c, 'data-cent-lista');
        }
        /* el tope ahora cuenta UNIDADES, no tarjetas: una sola tarjeta en 6
           puede llenarlo entera. Una tarjeta ya elegida no se bloquea a si
           misma (bloquearia su propia casilla al recalcular), solo las que
           todavia no se sumaron. */
        var bloquear = !on && (unidadesSel + q) > topeLibre();
        if (k) { k.disabled = bloquear; }
        c.classList.toggle('is-bloqueado', bloquear);
        c.classList.toggle('is-elegido', on);
      });
      if (elegidosTx) {
        elegidosTx.hidden = sel.length === 0;
        var b = elegidosTx.querySelector('b');
        if (b) { b.textContent = String(sel.length); }
        var pal = elegidosTx.querySelector('[data-rk-comps-palabra]');
        if (pal) { pal.textContent = sel.length === 1 ? 'elegido' : 'elegidos'; }
      }
      if (aviso) { aviso.hidden = unidadesSel < topeLibre(); }

      var aho = lista - tot;
      var t = dinero(tot);
      if (elTot && elTot.textContent.trim() !== t) { elTot.textContent = t; latir(elTot); }
      if (elCta) { elCta.textContent = t; }
      /* el boton de "TU PEDIDO" muestra SIEMPRE la misma cifra que el de
         arriba: es el mismo total, escrito en la misma pasada */
      if (elCtaPedido) { elCtaPedido.textContent = t; }
      if (rielCifra) { rielCifra.textContent = t; }
      if (elAho) { elAho.textContent = dinero(aho); }
      if (filaAho) { filaAho.hidden = aho <= 0; }
      /* cuantas lineas lleva el pedido: el producto base mas un renglon por
         complemento marcado (no por unidad: 3 frascos del mismo complemento
         siguen siendo una linea) */
      if (pedidoCuenta) {
        var lineas = 1 + sel.length;
        pedidoCuenta.textContent = lineas + (lineas === 1 ? ' producto' : ' productos');
      }
    };

    packs.forEach(function (p) {
      var r = p.querySelector('input[type="radio"]');
      var elegir = function () {
        packs.forEach(function (x) { x.classList.toggle('is-elegido', x === p); });
        elegido = p;
        if (r) { r.checked = true; }
        pintar();
      };
      p.addEventListener('click', elegir);
      if (r) { r.addEventListener('change', elegir); }
    });

    comps.forEach(function (c) {
      var k = casilla(c);
      if (!k) { return; }
      k.addEventListener('change', function () {
        /* red de seguridad: la casilla ya viene bloqueada con el tope lleno */
        if (k.checked && (unidadesElegidas()) > topeLibre()) { k.checked = false; }
        pintar();
      });
      /* Una casilla bloqueada no reacciona al clic, y en silencio eso parece
         un boton roto. Se muestra el aviso del tope y se hace latir. */
      c.addEventListener('click', function (ev) {
        if (ev.target.closest && ev.target.closest('[data-rk-comp-q-btn]')) { return; }
        if (k.disabled && aviso) { aviso.hidden = false; latir(aviso); }
      });
      /* botones 1 / 3 / 6: cambian la cantidad de ESTA tarjeta sin tocar su
         casilla (preventDefault+stopPropagation, mismo motivo que el boton
         de vista rapida: estan dentro de la misma <label>). Si el nuevo
         total de unidades se pasa del tope, se revierte y se avisa en vez
         de dejar una cantidad que despues la funcion de descuentos no
         reconoceria igual. */
      c.querySelectorAll('[data-rk-comp-q-btn]').forEach(function (qb) {
        qb.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          var nuevaQ = parseInt(qb.getAttribute('data-rk-comp-q-btn'), 10) || 1;
          var qActual = qtyDe(c);
          if (nuevaQ === qActual) { return; }
          var otras = unidadesElegidas() - (k.checked ? qActual : 0);
          if (otras + nuevaQ > topeLibre()) {
            if (aviso) { aviso.hidden = false; latir(aviso); }
            return;
          }
          c.setAttribute('data-rk-comp-q', String(nuevaQ));
          if (!k.checked) { k.checked = true; }
          pintar();
        });
      });
    });

    /* BOTON "AGREGAR" POR TARJETA (15-09-2026): "eso quiero ver en mi
       pagina" — cada tarjeta de complemento pide un boton propio, no una
       casilla que hay que marcar y despues ir a buscar el boton grande de
       compra.

       DOS INTENTOS ANTERIORES, LOS DOS DESCARTADOS PROBANDO DE VERDAD:
       1) form.requestSubmit() — reutilizaba el envio del formulario, que
          TERMINA en el checkout (ver mas abajo, "ir.click()"): cada clic
          en "Agregar" mandaba derecho a pagar en vez de sumar el
          complemento y dejar al cliente seguir mirando la pagina.
       2) cart/add.js directo (como el cross-sell "Combínalo con") — ya no
          iba al checkout, pero agregaba por un camino que el resumen "TU
          PEDIDO" de este mismo formulario no lee: el complemento quedaba
          de verdad en el carro (con su 40%) pero el total en pantalla se
          quedaba con el numero de antes, como si no se hubiera agregado
          nada. Se noto probando el boton, no revisando el codigo.

       La vista rapida de este mismo carrusel (mas abajo, "modo
       complemento") ya habia resuelto exactamente este problema: marca la
       MISMA casilla de la tarjeta y deja que el flujo de siempre (pintar())
       actualice resumen y total al vuelo. El alta real al carro ocurre
       recien cuando el cliente aprieta "Elegir mi pack" / "Comprar ahora",
       igual que si hubiera marcado la casilla a mano. Este boton hace lo
       mismo: un toque marca y pinta, nada de red todavia. */
    todosDoc('[data-rk-comp-agregar]').forEach(function (btn) {
      var c = btn.closest('[data-rk-comp]');
      var k = c ? casilla(c) : null;
      if (!k) { return; }

      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        /* ya agregado: el segundo clic lo saca. Antes no hacia nada y el
           boton quedaba con el rotulo "Agregado" sin respuesta; quitarlo
           obligaba a adivinar que la tarjeta entera era el control. */
        if (k.checked) {
          k.checked = false;
          k.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
        if (k.disabled) {
          if (aviso) { aviso.hidden = false; latir(aviso); }
          return;
        }
        k.checked = true;
        k.dispatchEvent(new Event('change', { bubbles: true }));
      });

      /* el texto del boton sigue al estado real de la casilla, la marque
         este boton, la vista rapida o el propio clic sobre la tarjeta */
      k.addEventListener('change', function () {
        btn.textContent = k.checked ? 'Agregado' : 'Agregar';
      });
    });

    /* UN SOLO CAMINO DE COMPRA (16-09-2026). El boton de "TU PEDIDO" no arma
       su propio carro: dispara el de arriba, que es el unico que envia el
       formulario y habla con /cart. Asi los dos muestran el mismo total
       (lo escribe la misma pintar()) y no hay forma de generar un pedido
       doble ni de que uno cobre algo distinto que el otro. */
    if (ctaPedido && cta) {
      ctaPedido.addEventListener('click', function (ev) {
        ev.preventDefault();
        if (ctaPedido.disabled) { return; }
        cta.click();
      });
    }

    /* quitar desde el resumen, sin pasar por el carrusel. todosDoc y no
       todos: el resumen salio del <form> junto con "TU PEDIDO". */
    todosDoc('[data-rk-res-quitar]').forEach(function (b) {
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        var v = b.getAttribute('data-rk-res-quitar');
        var c = comps.filter(function (x) { return x.getAttribute('data-rk-comp-var') === v; })[0];
        var k = c ? casilla(c) : null;
        /* dispatchEvent y no solo "checked = false": el boton "Agregar" de
           la tarjeta escucha "change" para volver a decir "Agregar" en vez
           de quedarse en "Agregado" con la casilla ya destildada */
        if (k) { k.checked = false; k.dispatchEvent(new Event('change', { bubbles: true })); }
        else { pintar(); }
        /* la fila se va con el boton que tenia el foco: se deja en el total
           para que el teclado no vuelva al principio de la pagina */
        if (elTot) {
          if (!elTot.hasAttribute('tabindex')) { elTot.setAttribute('tabindex', '-1'); }
          try { elTot.focus({ preventScroll: true }); } catch (e) { elTot.focus(); }
        }
      });
    });

    var mostrar = function (idx) {
      if (!comps.length) { return; }
      visible = (idx + comps.length) % comps.length;
      comps.forEach(function (c, n) { c.hidden = n !== visible; });
      if (cuenta) { cuenta.textContent = (visible + 1) + ' / ' + comps.length; }
    };
    /* LAS FLECHAS DESPLAZAN EL RIEL (16-09-2026). Antes llamaban a
       mostrar(), que escondia todas las tarjetas menos una: eso era del
       carrusel de una-a-la-vez, y desde que el bloque muestra las cinco
       juntas el CSS pisa ese [hidden], asi que el boton no hacia nada
       visible. Ahora empujan el riel una tarjeta, que es lo que el
       usuario pidio al sacar "Ver todos": ver el resto sin salir de la
       pagina.
       Y solo aparecen si hay algo mas que ver: se mide el desborde real
       del riel, no el ancho de pantalla. Con las cinco tarjetas cabiendo
       enteras no sobra nada que desplazar y el par de flechas estorba. */
    var pista = document.querySelector('.rk-comps__pista');
    var cajaComps = document.querySelector('[data-rk-comps]');
    var flechas = todosDoc('[data-rk-comps-ir]');
    var pasoRiel = function () {
      var t = pista && pista.querySelector('.rk-comp');
      if (!t) { return 200; }
      var ancho = t.getBoundingClientRect().width;
      var hueco = parseFloat(getComputedStyle(pista).columnGap) || 0;
      return Math.round(ancho + hueco);
    };
    var pintarFlechas = function () {
      if (!pista || !cajaComps) { return; }
      var sobra = pista.scrollWidth - pista.clientWidth;
      cajaComps.classList.toggle('tiene-riel', sobra > 4);
      flechas.forEach(function (b) {
        var d = parseInt(b.getAttribute('data-rk-comps-ir'), 10) || 1;
        b.disabled = d < 0 ? pista.scrollLeft <= 2 : pista.scrollLeft >= sobra - 2;
      });
    };
    flechas.forEach(function (b) {
      var d = parseInt(b.getAttribute('data-rk-comps-ir'), 10) || 1;
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        if (!pista) { return; }
        pista.scrollBy({ left: d * pasoRiel(), behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    if (pista) {
      pista.addEventListener('scroll', pintarFlechas, { passive: true });
      window.addEventListener('resize', pintarFlechas);
      pintarFlechas();
      /* las fotos entran despues y cambian el ancho del riel */
      window.addEventListener('load', pintarFlechas);
    }

    /* ---------- envio ---------- */
    var pidiendo = false;
    var soltar = function () {
      pidiendo = false;
      if (cta) { cta.removeAttribute('aria-busy'); cta.classList.remove('rk-cargando'); }
    };
    /* volver con el boton atras del navegador trae la pagina congelada con el
       boton girando: se suelta */
    window.addEventListener('pageshow', function (ev) { if (ev && ev.persisted) { soltar(); } });

    form.addEventListener('submit', function (ev) {
      if (!window.fetch || !window.Promise) { return; }
      ev.preventDefault();
      if (pidiendo || !elegido) { return; }
      pidiendo = true;
      if (falla) { falla.hidden = true; }
      if (cta) { cta.setAttribute('aria-busy', 'true'); cta.classList.add('rk-cargando'); }

      var n = parseInt(elegido.getAttribute('data-n'), 10) || 1;
      var quiero = {};
      marcados().forEach(function (c) { quiero[String(c.getAttribute('data-rk-comp-var'))] = qtyDe(c); });

      var json = function (u, datos) {
        return fetch(u, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(datos)
        }).then(function (r) { if (!r.ok) { throw new Error(String(r.status)); } return r.json(); });
      };

      fetch(raizUrl() + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) { throw new Error(String(r.status)); } return r.json(); })
        .then(function (carro) {
          var items = (carro && carro.items) || [];
          var updates = {}, hayCambios = false, agregar = [], puesto = {};

          /* QUIEN COBRA MIRA LAS PROPIEDADES DE LA LINEA      16-09-2026
             La funcion "RK PROMO packs y complementos" decide el precio
             leyendo _rk_origen de cada linea del carro. Este bloque
             reutilizaba lineas que ya estaban ahi sin mirar con que
             propiedades venian, y de ahi salian tres formas de cobrar algo
             distinto de lo que decia la pantalla:
               1. El producto base reutilizaba una linea marcada como
                  complemento (porque el cliente lo habia agregado antes
                  desde el carrusel de OTRA ficha). La funcion la trataba
                  como complemento y el pack de 6 se cobraba entero.
               2. Un complemento que ya estaba en el carro por otro camino
                  caia en "ya esta, no lo dupliques" y no se escribia nada:
                  ni la cantidad elegida aca, ni la propiedad que le da el
                  40%. La pagina mostraba 26.940 y el checkout cobraba
                  44.900.
               3. Una linea de "Combinalo con" (que si trae _rk_origen pero
                  no _rk_fuente) se quedaba con su cantidad vieja aunque el
                  cliente eligiera 3 o 6 en el carrusel.
             Regla nueva, en una sola frase: el producto base entra SIEMPRE
             como linea limpia, y todo complemento que se vaya a cobrar
             tiene que salir de aca con _rk_origen puesto y con la cantidad
             que el cliente eligio.
             Las propiedades NO se pueden editar con cart/update.js: una
             linea mal marcada se pone en cero y se vuelve a agregar. */
          var esComplemento = function (it) {
            return !!(it.properties && it.properties._rk_origen === 'complemento');
          };
          var esDeEsteCarrusel = function (it) {
            return esComplemento(it) && it.properties._rk_fuente === 'carrusel';
          };

          /* ---- producto base: solo sirven las lineas SIN marcar ---- */
          var suyas = [], suyasMarcadas = [];
          items.forEach(function (it) {
            if (String(it.variant_id) !== String(varId)) { return; }
            (esComplemento(it) ? suyasMarcadas : suyas).push(it);
          });
          suyasMarcadas.forEach(function (it) { updates[it.key] = 0; hayCambios = true; });
          if (suyas.length) {
            suyas.forEach(function (it, i) {
              var q = i === 0 ? n : 0;
              if (it.quantity !== q) { updates[it.key] = q; hayCambios = true; }
            });
          } else {
            agregar.push({ id: Number(varId), quantity: n });
          }

          /* ---- complementos ---- */
          items.forEach(function (it) {
            var v = String(it.variant_id);
            if (v === String(varId)) { return; }

            /* nacida en ESTE carrusel: este bloque es su dueño y la
               sincroniza o la saca (ver la nota de _rk_fuente del 15-09) */
            if (esDeEsteCarrusel(it)) {
              if (quiero[v] && !puesto[v]) {
                puesto[v] = true;
                if (it.quantity !== quiero[v]) { updates[it.key] = quiero[v]; hayCambios = true; }
              } else {
                updates[it.key] = 0; hayCambios = true;
              }
              return;
            }

            /* no la pidio aca: no se toca. Es de otro camino y no es
               asunto de este formulario (por eso existe _rk_fuente). */
            if (!quiero[v]) { return; }

            /* viene de "Combinalo con": ya cobra bien porque trae
               _rk_origen. Solo se ajusta a la cantidad elegida aca, y no
               se borra nunca. */
            if (esComplemento(it)) {
              puesto[v] = true;
              if (it.quantity !== quiero[v]) { updates[it.key] = quiero[v]; hayCambios = true; }
              return;
            }

            /* sin _rk_origen: entro por el catalogo, por una vista rapida o
               por su propia ficha, y asi la funcion NO le aplica el 40%. Se
               pone en cero y el bucle de abajo la vuelve a agregar marcada,
               que es la unica forma de ponerle propiedades. */
            updates[it.key] = 0; hayCambios = true;
          });

          Object.keys(quiero).forEach(function (v) {
            if (!puesto[v]) { agregar.push({ id: Number(v), quantity: quiero[v], properties: { _rk_origen: 'complemento', _rk_fuente: 'carrusel' } }); }
          });

          var paso = Promise.resolve();
          if (hayCambios) { paso = paso.then(function () { return json(raizUrl() + 'cart/update.js', { updates: updates }); }); }
          if (agregar.length) { paso = paso.then(function () { return json(raizUrl() + 'cart/add.js', { items: agregar }); }); }
          return paso;
        })
        .then(function () {
          try { document.dispatchEvent(new CustomEvent('rk:carro', { detail: { fuente: 'rk-packs' } })); } catch (e) {}
          if (ir) { ir.click(); } else { window.location.assign(raizUrl() + 'checkout'); }
        })
        .catch(function () {
          /* NO SE SIGUE AL CHECKOUT CON EL CARRO A MEDIAS (16-09-2026).
             Antes el catch hacia form.submit(), que lleva a pagar SOLO el
             pack: los complementos que el cliente acababa de elegir, y que
             "TU PEDIDO" le estaba sumando, se quedaban fuera sin ningun
             aviso. Pagaba una cosa distinta de la que vio. Ahora se suelta
             el boton y se avisa, que es reintentable y honesto. */
          soltar();
          if (falla) { falla.hidden = false; latir(falla); }
        });
    });

    /* lectura unica del carro para el tope. Va despues de pintar() a
       proposito: la pagina no espera a la red para quedar utilizable. */
    if (window.fetch) {
      fetch(raizUrl() + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (carro) {
          if (!carro || !carro.items) { return; }
          var mios = {};
          comps.forEach(function (c) { mios[String(c.getAttribute('data-rk-comp-var'))] = true; });
          lineasAjenas = carro.items.filter(function (it) {
            return it.properties && it.properties._rk_origen === 'complemento'
              && it.properties._rk_fuente !== 'carrusel'
              && mios[String(it.variant_id)];
          }).map(function (it) { return { v: String(it.variant_id), q: it.quantity }; });
          if (lineasAjenas.length) { pintar(); }
        })
        .catch(function () {});
    }

    pintar();
  }());

  /* ---------- 2. galeria de producto ----------
     Movil: track con scroll-snap, un slide = una foto, puntos debajo.
     Escritorio: los slides se apilan con position:absolute (CSS) y solo el
     .is-active se ve, con fundido en opacity; miniaturas eligen cual.
     Zoom con el cursor: transform-origin sigue al mouse, solo si el
     dispositivo tiene hover real (evita el "pseudo-hover" tactil).
     Visor: position:absolute (nunca fixed, rompe el iframe del editor de
     temas) dentro de .rk-pdp-root, que es full-bleed y position:relative. */
  var gal = document.querySelector('[data-rk-galeria]');
  if(gal){
    var track  = gal.querySelector('[data-rk-gal-track]'),
        slides = Array.prototype.slice.call(gal.querySelectorAll('[data-rk-gal-slide]')),
        dots   = Array.prototype.slice.call(gal.querySelectorAll('[data-rk-gal-dot]')),
        thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-rk-gal-thumb]')),
        marco  = gal.querySelector('.rk-gal__marco'),
        navs   = Array.prototype.slice.call(gal.querySelectorAll('[data-rk-gal-ir]')),
        cuenta = gal.querySelector('[data-rk-gal-actual]'),
        activo = 0;

    var irA = function(i, opts){
      opts = opts || {};
      if(i < 0 || i >= slides.length || !slides.length) return;
      activo = i;
      slides.forEach(function(s, idx){ s.classList.toggle('is-active', idx === i); });
      dots.forEach(function(d, idx){ d.setAttribute('aria-selected', idx === i ? 'true' : 'false'); });
      thumbs.forEach(function(t, idx){ t.setAttribute('aria-current', idx === i ? 'true' : 'false'); });
      if(cuenta){ cuenta.textContent = String(i + 1); }
      if(opts.desplazar !== false && track){
        slides[i].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', inline: 'nearest', block: 'nearest' });
      }
    };

    dots.forEach(function(d, i){ d.addEventListener('click', function(){ irA(i); actualizarVisor(); }); });
    thumbs.forEach(function(t, i){ t.addEventListener('click', function(){ irA(i); actualizarVisor(); }); });

    /* ---------- recorrer la galeria ----------
       Las flechas dan la vuelta a proposito en vez de deshabilitarse en los
       extremos: son pocas fotos y un boton que deja de responder se lee como
       roto. Es el mismo criterio que ya usaba el visor a pantalla completa. */
    var mover = function(paso){
      if(slides.length < 2) return;
      irA((activo + paso + slides.length) % slides.length);
      actualizarVisor();
    };
    navs.forEach(function(b){
      var paso = parseInt(b.getAttribute('data-rk-gal-ir'), 10) || 1;
      b.addEventListener('click', function(ev){ ev.preventDefault(); mover(paso); });
    });

    /* Teclado. El marco recibe el foco como un grupo, asi quien navega con
       tabulador llega a la galeria y la recorre sin tener que pasar por las
       ocho miniaturas una por una. */
    if(marco && slides.length > 1){
      marco.setAttribute('tabindex', '0');
      marco.setAttribute('role', 'group');
      marco.setAttribute('aria-label', 'Fotos del producto. Usa las flechas para cambiar.');
      marco.addEventListener('keydown', function(ev){
        var k = ev.key;
        if(k === 'ArrowRight'){ ev.preventDefault(); mover(1); }
        else if(k === 'ArrowLeft'){ ev.preventDefault(); mover(-1); }
        else if(k === 'Home'){ ev.preventDefault(); irA(0); actualizarVisor(); }
        else if(k === 'End'){ ev.preventDefault(); irA(slides.length - 1); actualizarVisor(); }
      });
    }

    /* Arrastre con el raton, solo donde las diapositivas estan apiladas (en
       telefono el track ya se desliza solo y meter mano ahi seria pelearse
       con el scroll nativo).
       El umbral existe para no robarle el clic al visor: por debajo de 45 px
       el gesto se considera un clic y el visor se abre como siempre. */
    if(marco && slides.length > 1 && window.matchMedia('(hover: hover) and (pointer: fine)').matches){
      var x0 = null, y0 = null, arrastro = false;
      marco.addEventListener('pointerdown', function(ev){
        if(ev.button !== 0) return;
        x0 = ev.clientX; y0 = ev.clientY; arrastro = false;
      });
      marco.addEventListener('pointermove', function(ev){
        if(x0 === null) return;
        var dx = ev.clientX - x0, dy = ev.clientY - y0;
        if(!arrastro && Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)){
          arrastro = true;
          gal.classList.add('is-arrastrando');
          mover(dx < 0 ? 1 : -1);
        }
      });
      var soltar = function(){
        x0 = null; y0 = null;
        gal.classList.remove('is-arrastrando');
        /* el flag se apaga en el siguiente ciclo para que el click que viene
           detras del pointerup todavia lo vea y se cancele */
        if(arrastro){ setTimeout(function(){ arrastro = false; }, 0); }
      };
      marco.addEventListener('pointerup', soltar);
      marco.addEventListener('pointercancel', soltar);
      marco.addEventListener('pointerleave', soltar);
      marco.addEventListener('click', function(ev){
        if(arrastro){ ev.preventDefault(); ev.stopPropagation(); }
      }, true);
    }

    /* movil: sincroniza puntos/miniaturas con el slide que quedo centrado
       tras un swipe, sin pelear con el scrollIntoView disparado por irA */
    if(track){
      var scrollFin;
      track.addEventListener('scroll', function(){
        clearTimeout(scrollFin);
        scrollFin = setTimeout(function(){
          if(!track.clientWidth) return;
          var centro = track.scrollLeft + track.clientWidth / 2;
          var i = Math.floor(centro / track.clientWidth);
          if(i !== activo && i >= 0 && i < slides.length){ irA(i, { desplazar:false }); }
        }, 80);
      }, { passive: true });
    }

    /* zoom al pasar el cursor, solo escritorio con hover real */
    if(!reduce && window.matchMedia('(hover: hover) and (pointer: fine)').matches){
      slides.forEach(function(s){
        var img = s.querySelector('img');
        if(!img) return;
        s.addEventListener('mousemove', function(ev){
          var r = s.getBoundingClientRect();
          var x = ((ev.clientX - r.left) / r.width) * 100,
              y = ((ev.clientY - r.top) / r.height) * 100;
          img.style.transformOrigin = x + '% ' + y + '%';
          img.style.transform = 'scale(1.8)';
        });
        s.addEventListener('mouseleave', function(){
          img.style.transform = '';
          img.style.transformOrigin = '';
        });
      });
    }

    /* ---------- visor a pantalla completa ---------- */
    var visor = gal.querySelector('[data-rk-gal-visor]');
    var actualizarVisor = function(){};

    if(visor){
      var raiz = visor.closest('.rk-pdp-root');
      var visorImg  = visor.querySelector('[data-rk-gal-visor-img]'),
          btnCerrar = visor.querySelector('[data-rk-gal-cerrar]'),
          btnPrev   = visor.querySelector('[data-rk-gal-prev]'),
          btnNext   = visor.querySelector('[data-rk-gal-next]'),
          previoFoco = null,
          pinchDist = null, pinchEscala = 1, toqueX = null;

      actualizarVisor = function(){
        var s = slides[activo];
        if(!s || !visorImg) return;
        visorImg.src = s.getAttribute('data-rk-gal-full') || (s.querySelector('img') || {}).src || '';
        visorImg.alt = (s.querySelector('img') || {}).alt || '';
        pinchEscala = 1;
        visorImg.style.transform = '';
      };

      var abrirVisor = function(ev){
        previoFoco = (ev && ev.currentTarget) || document.activeElement;
        actualizarVisor();
        /* EL VISOR ES position:fixed (16-09-2026).
           Era absolute dentro de .rk-pdp-root y por eso habia aca toda una
           cuenta para colocarlo a la altura del scroll. Dos fallas reales
           que eso no podia resolver:
           1. .rk-pdp-root lleva isolation:isolate, o sea que abre su PROPIO
              contexto de apilamiento con z-index:auto. El z-index:9000 del
              visor solo valia dentro de esa burbuja, asi que la cabecera
              pegajosa (su seccion va en z-index:60) se dibujaba ENCIMA del
              visor: el boton de cerrar quedaba tapado por la franja de
              aviso. Comprobado con elementFromPoint sobre el boton, que
              devolvia .rk-anuncio en vez del boton.
           2. Al ser absolute, el visor se iba con el scroll.
           Con fixed + inset:0 cubre siempre la pantalla y no hace falta
           calcular ninguna coordenada; y mientras esta abierto se le sube
           el z-index a .rk-pdp-root (clase rk-visor-abierto) para sacar esa
           burbuja por encima de la cabecera. Al cerrar vuelve a su sitio,
           asi que la cabecera sigue mandando el resto del tiempo. */
        visor.style.top = '';
        if (raiz) { raiz.classList.add('rk-visor-abierto'); }
        visor.hidden = false;
        document.body.classList.add('rk-gal-lock');
        var animar = function(){ visor.classList.add('is-abierto'); };
        if(reduce){ animar(); } else { requestAnimationFrame(animar); }
        if(btnCerrar){ btnCerrar.focus({ preventScroll: true }); }
      };

      var cerrarVisor = function(){
        if(visor.hidden) return;
        visor.classList.remove('is-abierto');
        document.body.classList.remove('rk-gal-lock');
        if (raiz) { raiz.classList.remove('rk-visor-abierto'); }
        var terminar = function(){ visor.hidden = true; };
        if(reduce){ terminar(); } else { setTimeout(terminar, 200); }
        if(previoFoco && previoFoco.focus){ previoFoco.focus({ preventScroll: true }); }
      };

      slides.forEach(function(s){
        var img = s.querySelector('img');
        if(img){ img.style.cursor = 'zoom-in'; img.addEventListener('click', abrirVisor); }
      });

      if(btnCerrar){ btnCerrar.addEventListener('click', cerrarVisor); }
      if(btnPrev){ btnPrev.addEventListener('click', function(){ irA((activo - 1 + slides.length) % slides.length); actualizarVisor(); }); }
      if(btnNext){ btnNext.addEventListener('click', function(){ irA((activo + 1) % slides.length); actualizarVisor(); }); }

      /* clic en el fondo, fuera de la imagen */
      visor.addEventListener('click', function(ev){ if(ev.target === visor){ cerrarVisor(); } });

      /* teclado: Escape, flechas, foco atrapado dentro del visor */
      visor.addEventListener('keydown', function(ev){
        if(ev.key === 'Escape'){ cerrarVisor(); return; }
        if(ev.key === 'ArrowLeft'){ if(btnPrev){ btnPrev.click(); } return; }
        if(ev.key === 'ArrowRight'){ if(btnNext){ btnNext.click(); } return; }
        if(ev.key === 'Tab'){
          var enfocables = visor.querySelectorAll('button');
          if(!enfocables.length) return;
          var primero = enfocables[0], ultimo = enfocables[enfocables.length - 1];
          if(ev.shiftKey && document.activeElement === primero){ ev.preventDefault(); ultimo.focus(); }
          else if(!ev.shiftKey && document.activeElement === ultimo){ ev.preventDefault(); primero.focus(); }
        }
      });

      /* dedo: deslizar para navegar (1 dedo), pellizcar para zoom (2 dedos) */
      var distancia = function(t){ return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY); };
      visor.addEventListener('touchstart', function(ev){
        if(ev.touches.length === 2){ pinchDist = distancia(ev.touches); toqueX = null; }
        else if(ev.touches.length === 1){ toqueX = ev.touches[0].clientX; pinchDist = null; }
      }, { passive:true });
      visor.addEventListener('touchmove', function(ev){
        if(ev.touches.length === 2 && pinchDist && visorImg){
          var d = distancia(ev.touches);
          var s = Math.min(3, Math.max(1, pinchEscala * (d / pinchDist)));
          visorImg.style.transform = s > 1 ? 'scale(' + s + ')' : '';
          visorImg.setAttribute('data-rk-escala', s);
        }
      }, { passive:true });
      visor.addEventListener('touchend', function(ev){
        if(visorImg && visorImg.hasAttribute('data-rk-escala')){
          pinchEscala = parseFloat(visorImg.getAttribute('data-rk-escala')) || 1;
        }
        if(ev.touches.length === 0){
          pinchDist = null;
          if(toqueX !== null){
            var dx = (ev.changedTouches[0] || {}).clientX - toqueX;
            if(pinchEscala <= 1 && Math.abs(dx) > 40){
              if(dx < 0 && btnNext){ btnNext.click(); } else if(dx > 0 && btnPrev){ btnPrev.click(); }
            }
          }
          toqueX = null;
        }
      });
    }

    irA(0, { desplazar:false });
  }

  /* ---------- 3. riel de compra: ancho real y aria-hidden fuera de movil ----------
     width:100vw en CSS puro puede incluir el ancho de la barra de scroll en
     algunos navegadores (el viewport que mide vw no siempre coincide con lo
     que realmente se ve si el navegador reserva espacio para la barra),
     dejando el borde derecho del riel unos pixeles fuera de la pantalla
     real. window.innerWidth no tiene ese problema — es siempre el ancho
     visible real — asi que se fija por JS en vez de depender solo del CSS.

     aria-hidden: display:none ya saca el riel del arbol de accesibilidad en
     escritorio en la enorme mayoria de casos, pero un lector de pantalla no
     deberia depender solo de eso para no anunciar los mismos botones de
     compra dos veces — se hace explicito y a prueba de fallos. */
  var riel = document.querySelector('.rk-riel');
  if(riel){
    var mqRiel = window.matchMedia('(min-width:900px)');
    var actualizarRiel = function(){
      /* innerWidth puede valer 0 mientras el navegador incrustado todavia no
         dimensiona su contenedor. Visto en vivo el 27-08-2026: el riel quedo
         con style="width: 0px" y desaparecio. Antes pasaba desapercibido
         porque el riel nacia escondido; ahora esta siempre visible.
         Ante una medida invalida se prefiere no escribir nada y dejar que
         mande el width:100vw del CSS, que es peor por la barra de scroll pero
         nunca es cero. */
      /* YA NO SE ESCRIBE EL ANCHO. Era un parche para que 100vw no incluyera
         la barra de scroll, y termino siendo la causa del problema opuesto:
         medido el 27-08-2026, innerWidth daba 453 en una pantalla de 390 y el
         riel salia 63px mas ancho que la pantalla.
         El CSS ahora usa left:0 + right:0, que mide el viewport real sin
         depender de ningun valor reportado. Si quedaba un ancho escrito de
         una carga anterior, se borra. */
      riel.style.removeProperty('width');
      riel.setAttribute('aria-hidden', mqRiel.matches ? 'true' : 'false');
    };
    actualizarRiel();
    /* Segunda pasada cuando la pagina termina de cargar: si la primera cayo
       en el instante en que el contenedor medía cero, esta la corrige. */
    window.addEventListener('load', actualizarRiel);
    window.addEventListener('resize', actualizarRiel);
    /* orientationchange ademas de resize: en algunos navegadores moviles el
       cambio de orientacion no dispara resize de forma confiable, o lo
       dispara con el valor viejo de innerWidth todavia en transito. */
    window.addEventListener('orientationchange', actualizarRiel);
    if(mqRiel.addEventListener){ mqRiel.addEventListener('change', actualizarRiel); }
  }

  /* ---------- 4. vista rapida del cross-sell (13-09-2026) ----------
     Pedido de Kike: "no quiero que se arranquen para otro lado los
     compradores". La foto y el nombre de cada tarjeta de "Combínalo con"
     ya no son <a href> al producto: son botones con data-rk-quickview que
     abren este modal.

     SIN PEDIR NADA POR RED. Todo el contenido (foto, titulo, categoria,
     gancho, precio, el posible -40%) ya viene resuelto en Liquid y colgado
     como data-* del propio boton (ver snippets/rk-cross-sell.liquid): abrir
     la vista rapida es copiar atributos a nodos, nunca un fetch. Es ademas
     la unica forma de garantizar que el modal muestre EXACTAMENTE el mismo
     precio que la tarjeta: si se volviera a calcular en JavaScript, un dia
     las dos cuentas se separan.

     "Agregar" adentro del modal repite el mismo patron a prueba de fallos
     que el bloque 7 (agregar al carro sin recargar): POST a /cart/add.js,
     confirma con /cart.js, avisa por rk:carro y por el canal de Dawn si
     existe. Se escribe aparte y no se reutiliza el listener del bloque 7
     porque ese se engancha una sola vez, al cargar la pagina, sobre los
     enlaces que existen en ese momento — el boton de este modal es unico y
     fijo, asi que le alcanza con su propio listener. */
  var qv = document.querySelector('[data-rk-qv]');
  var disparadoresQv = document.querySelectorAll('[data-rk-quickview]');
  if(qv && disparadoresQv.length){
    var qvFoto    = qv.querySelector('[data-rk-qv-foto]'),
        qvCat     = qv.querySelector('[data-rk-qv-cat]'),
        qvTit     = qv.querySelector('[data-rk-qv-tit]'),
        qvGancho  = qv.querySelector('[data-rk-qv-gancho]'),
        qvDesc    = qv.querySelector('[data-rk-qv-desc]'),
        qvBenes   = qv.querySelector('[data-rk-qv-benes]'),
        qvPrecio  = qv.querySelector('[data-rk-qv-precio]'),
        qvAntes   = qv.querySelector('[data-rk-qv-antes]'),
        qvChip    = qv.querySelector('[data-rk-qv-chip]'),
        qvVer     = qv.querySelector('[data-rk-qv-ver]'),
        qvAdd     = qv.querySelector('[data-rk-qv-add]'),
        qvAddTxt  = qv.querySelector('[data-rk-qv-add-txt]'),
        qvCerrar  = qv.querySelector('[data-rk-qv-cerrar]'),
        previoFocoQv = null,
        /* MODO COMPLEMENTO (14-09-2026): la vista rapida ahora tambien se
           abre desde las tarjetas del carrusel "Sumale un complemento"
           (snippets/rk-packs.liquid). Ahi "Agregar al carro" no puede ser
           un alta directa a /cart/add.js como en el cross-sell: rompería el
           precio, porque el 40%/50% de un complemento depende de la
           propiedad de linea _rk_origen (ver rk-app-descuentos) que solo
           pone el flujo normal del formulario de packs. En modo complemento
           el boton en cambio marca la MISMA casilla de la tarjeta y deja
           que ese flujo, ya probado, haga el resto — asi el modal nunca
           puede cobrar un precio distinto al que la tarjeta prometio. */
        qvModo = 'normal',
        qvCompVar = '';

    var llenarQv = function(btn){
      var img = btn.getAttribute('data-rk-qv-img');
      qvFoto.innerHTML = img ? '<img src="' + img + '" alt="" loading="eager" width="800" height="800">' : '';
      qvCat.textContent = btn.getAttribute('data-rk-qv-cat') || '';
      qvCat.hidden = !qvCat.textContent;
      qvTit.textContent = btn.getAttribute('data-rk-qv-tit') || '';
      qvGancho.textContent = btn.getAttribute('data-rk-qv-gancho') || '';
      qvGancho.hidden = !qvGancho.textContent;
      if(qvDesc){
        qvDesc.textContent = btn.getAttribute('data-rk-qv-desc') || '';
        qvDesc.hidden = !qvDesc.textContent;
      }
      /* LOS 4 CUADROS (14-09-2026): clonados de un <template> propio de la
         tarjeta (ver snippets/rk-packs.liquid / rk-cross-sell.liquid), no
         reconstruidos aqui — asi el icono sale identico al de la ficha, sin
         duplicar la tabla nombre-de-icono -> SVG en JavaScript. */
      if(qvBenes){
        qvBenes.innerHTML = '';
        var varBenes = btn.getAttribute('data-rk-qv-var');
        var tplBenes = varBenes ? document.querySelector('template[data-rk-qv-benes-tpl="' + varBenes + '"]') : null;
        if(tplBenes && tplBenes.content && tplBenes.content.childElementCount){
          qvBenes.appendChild(tplBenes.content.cloneNode(true));
          qvBenes.hidden = false;
        } else {
          qvBenes.hidden = true;
        }
      }
      qvPrecio.textContent = btn.getAttribute('data-rk-qv-precio') || '';
      var antes = btn.getAttribute('data-rk-qv-antes') || '';
      qvAntes.textContent = antes;
      qvAntes.hidden = !antes;
      var chip = btn.getAttribute('data-rk-qv-chip') || '';
      qvChip.textContent = chip;
      qvChip.hidden = !chip;
      qvVer.href = btn.getAttribute('data-rk-qv-url') || '#';
      qvAdd.setAttribute('data-var', btn.getAttribute('data-rk-qv-var') || '');
      qvAdd.removeAttribute('aria-busy');
      qvModo = btn.getAttribute('data-rk-qv-modo') || 'normal';
      qvCompVar = btn.getAttribute('data-rk-qv-comp-var') || '';
      qvAddTxt.textContent = qvModo === 'complemento' ? 'Sumar este complemento' : 'Agregar al carro';
    };

    var abrirQv = function(ev){
      ev.preventDefault();
      ev.stopPropagation();
      llenarQv(ev.currentTarget);
      previoFocoQv = ev.currentTarget;
      qv.hidden = false;
      document.body.classList.add('rk-gal-lock');
      var animar = function(){ qv.classList.add('is-abierto'); };
      if(reduce){ animar(); } else { requestAnimationFrame(animar); }
      if(qvCerrar){ qvCerrar.focus({ preventScroll: true }); }
    };

    var cerrarQv = function(){
      if(qv.hidden){ return; }
      qv.classList.remove('is-abierto');
      document.body.classList.remove('rk-gal-lock');
      var terminar = function(){ qv.hidden = true; };
      if(reduce){ terminar(); } else { setTimeout(terminar, 200); }
      if(previoFocoQv && previoFocoQv.focus){ previoFocoQv.focus({ preventScroll: true }); }
    };

    disparadoresQv.forEach(function(btn){ btn.addEventListener('click', abrirQv); });
    if(qvCerrar){ qvCerrar.addEventListener('click', cerrarQv); }
    qv.addEventListener('click', function(ev){ if(ev.target === qv){ cerrarQv(); } });
    qv.addEventListener('keydown', function(ev){
      if(ev.key === 'Escape'){ cerrarQv(); return; }
      if(ev.key !== 'Tab'){ return; }
      var enfocables = qv.querySelectorAll('button, a[href]');
      if(!enfocables.length){ return; }
      var primero = enfocables[0], ultimo = enfocables[enfocables.length - 1];
      if(ev.shiftKey && document.activeElement === primero){ ev.preventDefault(); ultimo.focus(); }
      else if(!ev.shiftKey && document.activeElement === ultimo){ ev.preventDefault(); primero.focus(); }
    });

    if(qvAdd && window.fetch){
      qvAdd.addEventListener('click', function(){
        if(qvModo === 'complemento'){
          var tarjeta = qvCompVar ? document.querySelector('[data-rk-comp][data-rk-comp-var="' + qvCompVar + '"]') : null;
          var casillaComp = tarjeta ? tarjeta.querySelector('[data-rk-comp-check]') : null;
          if(casillaComp && !casillaComp.disabled && !casillaComp.checked){
            casillaComp.checked = true;
            casillaComp.dispatchEvent(new Event('change', { bubbles: true }));
          }
          cerrarQv();
          return;
        }
        var vid = parseInt(qvAdd.getAttribute('data-var'), 10);
        if(!vid){ return; }
        qvAdd.setAttribute('aria-busy', 'true');
        qvAddTxt.textContent = 'Agregando...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
        })
        .then(function(r){ if(!r.ok){ throw new Error('add'); } return r.json(); })
        .then(function(){ return fetch('/cart.js').then(function(r){ return r.json(); }); })
        .then(function(c){
          document.dispatchEvent(new CustomEvent('rk:carro', { detail: { count: c.item_count } }));
          if(typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.cartUpdate){
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rk-quickview', cartData: c });
          }
          qvAddTxt.textContent = 'Agregado';
          qvAdd.removeAttribute('aria-busy');
          setTimeout(cerrarQv, 900);
        })
        .catch(function(){
          qvAddTxt.textContent = 'Agregar al carro';
          qvAdd.removeAttribute('aria-busy');
          window.location.href = qvVer.href;
        });
      });
    }
  }
})();

/* ---------- 9. el globo de WhatsApp se aparta de la zona de compra ----------
   16-09-2026. En telefono el boton flotante quedaba encima del pack de 6
   unidades y de las tarjetas de complementos: dos zonas que se tocan, asi
   que tapaba controles reales. Mientras el bloque de compra (packs, boton,
   franja de confianza y complementos) esta a la vista, el globo se aparta;
   apenas sale de pantalla, vuelve. Solo en telefono: en escritorio nunca
   estorbo porque el contenido no llega a esa esquina.

   IntersectionObserver y no scroll: el navegador avisa cuando cambia, sin
   recalcular en cada pixel de scroll. Si el navegador no lo soporta, el
   globo se queda como estaba, que es el comportamiento de siempre. */
(function () {
  var wsp = document.querySelector('.rk-wsp');
  if (!wsp || !window.IntersectionObserver || !window.matchMedia) { return; }
  /* [data-rk-pedido] se suma el 16-09-2026: el bloque "TU PEDIDO" trae el
     SEGUNDO boton de compra ("COMPRAR TODO"), y el globo reaparecia justo
     encima de el al entrar en pantalla. */
  var zonas = [
    document.querySelector('[data-rk-packs]'),
    document.querySelector('[data-rk-comps]'),
    document.querySelector('[data-rk-pedido]')
  ].filter(Boolean);
  if (!zonas.length) { return; }

  var mq = window.matchMedia('(max-width:767px)');
  var visibles = 0;
  var aplicar = function () {
    wsp.classList.toggle('is-apartado', mq.matches && visibles > 0);
  };
  var obs = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (e.isIntersecting) { e.target.dataset.rkWspVisible = '1'; }
      else { delete e.target.dataset.rkWspVisible; }
    });
    visibles = zonas.filter(function (z) { return z.dataset.rkWspVisible; }).length;
    aplicar();
  }, { rootMargin: '-10% 0px -10% 0px' });

  /* Apartado de entrada. El observador entrega su primera lectura un cuadro
     despues de pintar, y en ese cuadro el globo alcanzaba a dibujarse encima
     de la franja de confianza (se ve en la captura de la primera pantalla).
     En telefono la zona de compra siempre esta arriba del todo, asi que al
     cargar la respuesta correcta se conoce de antemano: se aparta ya, y el
     observador lo devuelve en cuanto la zona sale de pantalla. */
  if (mq.matches) { wsp.classList.add('is-apartado'); }

  zonas.forEach(function (z) { obs.observe(z); });
  if (mq.addEventListener) { mq.addEventListener('change', aplicar); }
}());


/* ---------- 10. cuenta regresiva del precio de lanzamiento ----------
   16-09-2026. La segunda linea del banner decia una fecha escrita a mano
   en el ajuste del tema ("Hasta el viernes 18, 23:59"): el dia 19 seguia
   ahi, prometiendo algo vencido. Ahora el ajuste guarda la fecha de corte
   en ISO con huso de Chile y esto la convierte, cada segundo, en dias,
   horas, minutos y segundos.

   SE CALCULA EN EL NAVEGADOR, NO EN LIQUID, por lo mismo que las fechas de
   entrega (ver snippets/rk-entrega.liquid): Shopify cachea el HTML y una
   cuenta calculada al renderizar nace vieja.

   Pasada la fecha NO se queda contando en negativo ni desaparece en
   silencio: el bloque se apaga (clase is-vencido) y cambia el texto. */
(function () {
  var caja = document.querySelector('[data-rk-lanz]');
  if (!caja) { return; }
  var elCuenta = caja.querySelector('[data-rk-lanz-cuenta]');
  var elLinea = caja.querySelector('[data-rk-lanz-linea]');
  var fin = new Date(caja.getAttribute('data-rk-lanz-fin') || '').getTime();
  var nota = caja.getAttribute('data-rk-lanz-nota') || '';

  if (!isFinite(fin)) {
    /* sin fecha valida no se inventa una cuenta: se deja solo el rotulo */
    if (elCuenta) { elCuenta.hidden = true; }
    var sep = caja.querySelector('.rk-lanzamiento__sep');
    if (sep) { sep.hidden = true; }
    return;
  }

  var dosCifras = function (n) { return n < 10 ? '0' + n : String(n); };

  var fechaEnPalabras = function (d) {
    try {
      /* dia de la semana + numero ("viernes 18"): es como lo dice el
         usuario y entra en una linea en telefono, donde "18 de septiembre
         de 2026" se cortaba con puntos suspensivos */
      return new Intl.DateTimeFormat('es-CL', {
        weekday: 'long', day: 'numeric', timeZone: 'America/Santiago'
      }).format(d);
    } catch (e) { return ''; }
  };

  /* la linea de abajo la escribe el ajuste del tema y lleva {fecha} donde
     va el dia de corte, para no dejar el mes escrito a mano en dos sitios */
  if (elLinea) {
    var enPalabras = fechaEnPalabras(new Date(fin));
    if (nota) {
      elLinea.innerHTML = nota
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace('{fecha}', '<strong>' + enPalabras + '</strong>');
    }
  }

  var tic = null;
  var pintarCuenta = function () {
    var resta = fin - Date.now();
    if (resta <= 0) {
      caja.classList.add('is-vencido');
      /* y con el banner se apaga el rotulo "PROMO LANZAMIENTO" de la tarjeta
         recomendada (16-09-2026). Si no, la pagina se contradice sola: arriba
         "promocion finalizada" y en el pack un chip anunciando la misma promo.
         Los "% menos" y el "Ahorras" NO se tocan: esos siguen siendo ciertos,
         el descuento por pack no depende de esta fecha. */
      var raizFicha = document.querySelector('.rk-pdp-root');
      if (raizFicha) { raizFicha.classList.add('rk-lanzamiento-vencido'); }
      if (elCuenta) { elCuenta.textContent = 'promocion finalizada'; }
      if (elLinea) { elLinea.textContent = 'Revisa las promociones vigentes antes de comprar.'; }
      if (tic) { clearInterval(tic); }
      return;
    }
    var dias = Math.floor(resta / 86400000); resta %= 86400000;
    var horas = Math.floor(resta / 3600000); resta %= 3600000;
    var mins = Math.floor(resta / 60000); resta %= 60000;
    var segs = Math.floor(resta / 1000);
    if (elCuenta) {
      elCuenta.textContent = dias + 'd ' + dosCifras(horas) + 'h ' + dosCifras(mins) + 'm ' + dosCifras(segs) + 's';
    }
  };

  pintarCuenta();
  tic = setInterval(pintarCuenta, 1000);
}());
